import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import * as auth from "../../store/ducks/auth.duck";
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Divider, Link, Tab } from '@material-ui/core';
import MaterialTable from 'material-table';
import Chart from "react-google-charts";
import asyncValidate from './asyncValidate';
import { Button, Popover, PopoverHeader, PopoverBody, TabPane } from 'reactstrap';
import ReactDOM from 'react-dom';
import { Overlay } from 'react-bootstrap';
import moment from 'moment';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { referralParamsSubscriber, referralParamsService } from '../../services/dataTransferService'
import axiosAPI from '../../api/Scoreboardapi';
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import { Tabs } from "react-bootstrap";

import Loader from 'react-loader-advanced';
import { Helmet } from "react-helmet";
import LeftMenu from "./LeftMenu";
import { CompareSharp } from '@material-ui/icons';

library.add(fas)

// Styles
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      currentSortOrder: "DESC",
      sortBy: "id",
      rowsPerPage: 10,
      totalRecords: 0,
      popoverOpen: false,
      popover: [],
      popoverNonPap: [],
      selectedPtKey: 0,
      selectedPatientName: '',
      panel1: 'panel1',
      panel2: 'panel2',
      panel3: 'panel3',
      showFilter: false,
      salesOrderDiv: null,
      isChangeChartDdl: false,
      alert: '',
      showModal: false,
      isLoading: true,
      isLoadingNonPap: true,
      statusParam: "",
      complianceRiskParam: "",
      isVisible: true,
      isClicked: false,
      isVisibleCompliance: true,
      pt_PhoneNumberIsHidden: true,
      pt_MobileNumberIsHidden: true,
      compliancePctIsHidden: true,
      daysSinceSetupIsHidden: true,
      compliantDaysSinceSetupIsHidden: true,
      isClickedIsHidden: true,
      soCreateDtIsHidden: true,
      deliveredDtIsHidden: true,
      equipmentIsHidden: true,
      parMachineTypeIsHidden: true,
      maskTypeIsHidden: true,
      orderStatusIsHidden: false,
      orderNoteIsHidden: false,
      ddlSelectedOption: "",
      isLoadingAdherenceBreakdownsChart: false,
      isLoadingAdherenceBreakdownsChartByOption: false,
      isLoadingFullOrderBreakdowns: false,
      isLoadingComplianceNonCompliance: false,
      isLoadingDeliveredUndelivered: false,
      isLoadingNonPapFullOrderBreakDowns: true,
      isLoadingNonPapDeliveredUndelivered: false,
      currentSortOrderPap: { defaultSort: 'desc' },
      currentSortOrderNonPap: { defaultSort: 'desc' },
      sortByNonPap: 'id',
      isLoadingDocument: false,
      isLeftMenuVisible: false,
      breakdownClass: '',
      trendsClass: '',
      detailsClass: '',
      isOpen: true,
      sleepScreenerAccess: '',
      globalSummaryAccess: '',
      descPopoverOpen: false,
      selectedDescription: '',
      storeNonPapPatientState: false,
      popupDetailName:'',
      showPatientDetails:true,
      showPatientNotes:false,
      expandPatientNoteFor:'',
      patientNoteList: [],
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.changeSearch = this.changeSearch.bind(this);
    this.state.salesOrderDiv = React.createRef()
  }

  toggleLeftMenuDesktop = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

    descPopverToggle = (data = []) => {
        let desc = '';
        if (data) {
            desc = data.description
        }
        this.setState({
            descPopoverOpen: !this.state.descPopoverOpen,
            selectedDescription: desc
        })
    }

  componentDidMount() {
    this.props.checkForMenuItemAccessRequest(this.props.referralParam, )
    this.props.saveSalesFilter([], true)
    this.props.fetchMaskTypeListRequest({"OrganizationParam": this.props.organizationParam, "ReferralParam": this.props.referralParam});
    // Commented as it was causing double API call
    // this.props.clearFilter({
    //   "isFilterClear": true,
    // });

    let $this = this;
    referralParamsSubscriber.subscribe((data) => {
      setTimeout(() => {
        if (data == "" || localStorage.getItem('loadNewReferralParam') == '1') {
          localStorage.setItem('loadNewReferralParam', '');
          localStorage.setItem('newReferralParamForPieChartSelection', '');
          if (this.props.isPapUser == 1)
            this.props.fetchChartDetailRequest({ "AuthToken": this.props.AuthToken, "OrganizationParam": this.props.organizationParam, "ReferralParam": this.props.referralParam, "UserId": this.props.userId });
          if (this.props.isPapUser == 1)
            this.props.fetchDashboardDetailRequest({ "AuthToken": this.props.AuthToken, "OrganizationParam": this.props.organizationParam, "ReferralParam": this.props.referralParam, "RoleId": this.props.roleId, "UserId": this.props.userId });
          if (this.props.isPapUser == 1)
            this.props.fetchSalesOrderFilterListRequest({
              "statusParam": "",
              "salesRepParam": "",
              "doctorParam": "",
              "doctorNameParam": "",
              "doctorFirstNameParam": "",
              "doctorLastNameParam": "",
              "insuranceParam": "",
              "maskTypeParam": "",
              "complianceRiskParam": "",
              "equipmentTypeParam": "",
              "daysSinceSetupParam": "",
              "organizationParam": this.props.organizationParam,
              "referralParam": this.props.referralParam,
              // "limitParam": "10000",
              "startDate": "",
              "endDate": "",
              "patientNameParam": "",
              "patientFirstNameParam": "",
              "patientNameLastParam": "",
              "dateOfBirthParam": "",
              // "rowsToSkip": "0",
              "orderByFieldParam": "OrderStatus",
              "sortOrderParam": "asc",
              "PageSize": this.state.rowsPerPage,
              "PageNo": this.state.currentPage
            });
          if (this.props.isPapUser == 0) {
            $this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
              ReferralParam: this.props.referralParam,
              IsStatusNameParam: false,
              StatusNameParam: ""
            });
            $this.props.fetchNonPAPDashboardDetailsRequest({
              ReferralParam: this.props.referralParam,
              RoleId: this.props.roleId,
              OrganizationParam: this.props.organizationParam
            });
            $this.props.fetchNonPAPChartDetailRequest({
              ReferralParam: this.props.referralParam,
              OrganizationParam: this.props.organizationParam
            });
          }
        } else {
          localStorage.setItem('newReferralParamForPieChartSelection', data);
          if (this.props.isPapUser == 1)
            localStorage.setItem('newReferralParamForPieChartSelection', data);
            $this.props.fetchChartDetailRequest({
              AuthToken: this.props.AuthToken,
              OrganizationParam: this.props.organizationParam,
              ReferralParam: `${data}`,
              UserId: this.props.userId
            });
          if (this.props.isPapUser == 1)
            $this.props.fetchDashboardDetailRequest({
              AuthToken: this.props.AuthToken,
              OrganizationParam: this.props.organizationParam,
              ReferralParam: `${data}`,
              RoleId: this.props.roleId,
              UserId: this.props.userId
            });
          if (this.props.isPapUser == 1)
            $this.props.fetchSalesOrderFilterListRequest({
              "statusParam": "",
              "salesRepParam": "",
              "doctorParam": "",
              "doctorNameParam": "",
              "doctorFirstNameParam": "",
              "doctorLastNameParam": "",
              "insuranceParam": "",
              "maskTypeParam": "",
              "complianceRiskParam": "",
              "equipmentTypeParam": "",
              "daysSinceSetupParam": "",
              "organizationParam": this.props.organizationParam,
              "referralParam": `${data}`,
              // "limitParam": "10000",
              "startDate": "",
              "endDate": "",
              "patientNameParam": "",
              "patientFirstNameParam": "",
              "patientNameLastParam": "",
              "dateOfBirthParam": "",
              // "rowsToSkip": "0",
              "orderByFieldParam": "OrderStatus",
              "sortOrderParam": "asc",
              "PageSize": this.state.rowsPerPage,
              "PageNo": this.state.currentPage
            });
          else {
            this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
              ReferralParam: `${data}`,
              IsStatusNameParam: false,
              StatusNameParam: ""
            });
            this.props.fetchNonPAPDashboardDetailsRequest({
              ReferralParam: `${data}`,
              RoleId: this.props.roleId,
              OrganizationParam: this.props.organizationParam
            });
            this.props.fetchNonPAPChartDetailRequest({
              ReferralParam: `${data}`,
              OrganizationParam: this.props.organizationParam
            });
          }
        }
      }, 1000)
    })
  }
    componentWillReceiveProps(nextProps) {
        if (nextProps.checkForMenuItemAccess.length > 0 || nextProps.checkForMenuItemAccess.length == undefined) {
            if (nextProps.checkForMenuItemAccess.length == undefined) {
                if (nextProps.checkForMenuItemAccess.payload != undefined) {
                    if (nextProps.checkForMenuItemAccess.payload.success == false) {
                        localStorage.clear();
                        window.location.reload();
                    }
                }
            }
        }

    if ((nextProps.checkForMenuItemAccess.success != undefined && nextProps.checkForMenuItemAccess.success == true)) {
        //if (localStorage.getItem('IsMaintenanceMsgDisplayed') == "false") {
        //    this.displayAlert('6/18/21 - 6/21/21 : Due to system maintenance, patient and order information may not be up-to-date during this time period.', '', 'info');
        //    localStorage.setItem("IsMaintenanceMsgDisplayed", true);
        //}

      var storedUserData = localStorage.getItem('persist:userData');
      var parsedStoreUserData = JSON.parse(storedUserData);

      var user = JSON.parse(parsedStoreUserData.user);
      user.sleepScreenerAccess = nextProps.checkForMenuItemAccess.sleepScreenerAccess;
      user.globalSummaryAccess = nextProps.checkForMenuItemAccess.globalSummaryAccess;
        
      parsedStoreUserData.user = JSON.stringify(user);
      var newUserData = JSON.stringify(parsedStoreUserData);
      localStorage.setItem("persist:userData", newUserData);
      this.setState({ sleepScreenerAccess: nextProps.checkForMenuItemAccess.sleepScreenerAccess });
      this.setState({ globalSummaryAccess: nextProps.checkForMenuItemAccess.globalSummaryAccess });
    }
    if (nextProps.userDataLoading == false) {
      this.setState({ isLoading: false });
    }
    else {
      this.setState({ isLoading: true });
    }
    if (nextProps.adherenceBreakdownDetail) {
      if (nextProps.adherenceBreakdownDetail.length > 0 && nextProps.adherenceBreakdownDetail != this.props.adherenceBreakdownDetail) {
        this.setState({ isLoadingAdherenceBreakdownsChartByOption: false });
      }
    }
    else {
      this.setState({ isLoadingAdherenceBreakdownsChartByOption: false });
    }

    if (nextProps.dashboardDetailsOrderBreakDownLoading == false) {
      this.setState({ isLoadingFullOrderBreakdowns: false });
      this.setState({ isLoadingAdherenceBreakdownsChart: false });
    } else {
      this.setState({ isLoadingFullOrderBreakdowns: true });
      this.setState({ isLoadingAdherenceBreakdownsChart: true });
    }

    if (nextProps.chartNonPapDataDeliveredUndeliveredLoading == false) {
      this.setState({ isLoadingNonPapDeliveredUndelivered: false })
    } else {
      this.setState({ isLoadingNonPapDeliveredUndelivered: true })
    }

    if (nextProps.nonPAPDashboardDetailsLoading == false) {
      this.setState({ isLoadingNonPapFullOrderBreakDowns: false })
    } else {
      this.setState({ isLoadingNonPapFullOrderBreakDowns: true })
    }

    if (nextProps.nonPAPSalesOrderDetailsListByStatusLoading == false) {
      this.setState({ isLoadingNonPap: false })
    } else {
      this.setState({ isLoadingNonPap: true })
    }

    if (nextProps.nonPAPSalesOrderDetailsListByStatusLoading == false) {
      this.setState({ isLoadingNonPap: false });
    } else {
      this.setState({ isLoadingNonPap: true });

    }
    if (nextProps.chartDataLoading == false) {
      this.setState({ isLoadingComplianceNonCompliance: false })
      this.setState({ isLoadingDeliveredUndelivered: false })
    } else {
      this.setState({ isLoadingComplianceNonCompliance: true })
      this.setState({ isLoadingDeliveredUndelivered: true })
    }

    if (nextProps.isScrollToList && nextProps.salesFilter && nextProps.salesFilter.length > 0) {
      this.scrollToSalesList(nextProps.salesFilter)
    }
    if (nextProps.nonPAPPatientDetail.length > 0 && nextProps.nonPAPPatientDetail != this.props.nonPAPPatientDetail) {
      this.setState({ isLoadingNonPapPopover: false })
        }

    if (nextProps.nonPAPPatientCounter == true) {
        if (document.getElementsByClassName("bs-popover-auto")[0] != undefined) {
            document.getElementsByClassName("bs-popover-auto")[0].parentElement.remove('show');
            this.displayAlert('Patient information not found for this patient.', '', 'error');
            this.props.storeNonPapPatientDataNull();
        }
    }
    if (nextProps.nonPAPPatientDetail.length > 0 && nextProps.nonPAPPatientDetail != this.props.nonPAPPatientDetail) {
        this.setState({ isLoadingNonPapPopover: false });
    }

    if (nextProps.userDataAdherenceInfo.length > 0 && nextProps.userDataAdherenceInfo != this.props.userDataAdherenceInfo) {
      this.setState({ isLoadingNonPapPopover: false })
    }

  }
  // componentDidUpdate() {
  // setTimeout(() => {
  // if (localStorage.getItem('legendNameOrdereBreakDowns') != null) {
  //   this.setState({ panel3: 'panel3' });
  //   window.scrollTo({
  //     top: this.state.salesOrderDiv.current.offsetTop,
  //     behavior: 'smooth'
  //   })
  //   this.setState({ isLoading: true });
  //   this.setState({ currentPage: 0 });
  //   this.setState({ isClicked: false })

  //   if (localStorage.getItem('legendNameOrdereBreakDowns') == "Delivered") {
  //     this.setState({ pt_PhoneNumberIsHidden: true })
  //     this.setState({ pt_MobileNumberIsHidden: true })
  //     this.setState({ compliancePctIsHidden: true })
  //     this.setState({ daysSinceSetupIsHidden: true })
  //     this.setState({ compliantDaysSinceSetupIsHidden: true })
  //     this.setState({ isClickedIsHidden: true })
  //     this.setState({ soCreateDtIsHidden: false })
  //     this.setState({ deliveredDtIsHidden: false })
  //     this.setState({ equipmentIsHidden: false })
  //     this.setState({ parMachineTypeIsHidden: false })
  //     this.setState({ maskTypeIsHidden: false })
  //     this.setState({ orderStatusIsHidden: false })
  //     this.setState({ orderNoteIsHidden: true })
  //   }
  //   else {
  //     this.setState({ pt_PhoneNumberIsHidden: true })
  //     this.setState({ pt_MobileNumberIsHidden: true })
  //     this.setState({ compliancePctIsHidden: true })
  //     this.setState({ daysSinceSetupIsHidden: true })
  //     this.setState({ compliantDaysSinceSetupIsHidden: true })
  //     this.setState({ isClickedIsHidden: true })
  //     this.setState({ soCreateDtIsHidden: true })
  //     this.setState({ deliveredDtIsHidden: true })
  //     this.setState({ equipmentIsHidden: true })
  //     this.setState({ parMachineTypeIsHidden: true })
  //     this.setState({ maskTypeIsHidden: true })
  //     this.setState({ orderStatusIsHidden: false })
  //     this.setState({ orderNoteIsHidden: false })
  //   }
  //   this.setState({ statusParam: localStorage.getItem('legendNameOrdereBreakDowns') })
  //   this.props.fetchSalesOrderFilterListRequest({
  //     "statusParam": localStorage.getItem('legendNameOrdereBreakDowns'),
  //     "salesRepParam": "",
  //     "doctorParam": "",
  //     "doctorNameParam": "",
  //     "doctorFirstNameParam": "",
  //     "doctorLastNameParam": "",
  //     "insuranceParam": "",
  //     "maskTypeParam": "",
  //     "complianceRiskParam": "",
  //     "equipmentTypeParam": "",
  //     "daysSinceSetupParam": "",
  //     "organizationParam": this.props.organizationParam,
  //     "referralParam": this.props.referralParam,
  //     // "limitParam": "10000",
  //     "startDate": "",
  //     "endDate": "",
  //     "patientNameParam": "",
  //     "patientFirstNameParam": "",
  //     "patientNameLastParam": "",
  //     "dateOfBirthParam": "",
  //     // "rowsToSkip": "0",
  //     "orderByFieldParam": "OrderStatus",
  //     "sortOrderParam": "asc",
  //     "PageSize": this.state.rowsPerPage,
  //     "PageNo": 0,
  //   });

  //   let salesFilterList = []
  //   salesFilterList.push({ name: 'Order Status', value: localStorage.getItem('legendNameOrdereBreakDowns') })
  //   this.props.saveSalesFilter(salesFilterList, true)

  //   localStorage.removeItem('legendNameOrdereBreakDowns');

  // }

  // if (localStorage.getItem('legendNameAdherenceBreakDowns') != null) {
  //   this.setState({ panel3: 'panel3' });
  //   window.scrollTo({
  //     top: this.state.salesOrderDiv.current.offsetTop,
  //     behavior: 'smooth'
  //   })
  //   this.setState({ isLoading: true });
  //   this.setState({ currentPage: 0 });
  //   this.setState({ isClicked: true });
  //   if (this.state.ddlSelectedOption == "By Adherence Status" || "By Device") {
  //     this.setState({ pt_PhoneNumberIsHidden: false })
  //     this.setState({ pt_MobileNumberIsHidden: false })
  //     this.setState({ compliancePctIsHidden: false })
  //     this.setState({ daysSinceSetupIsHidden: false })
  //     this.setState({ compliantDaysSinceSetupIsHidden: false })
  //     this.setState({ isClickedIsHidden: false })
  //     this.setState({ soCreateDtIsHidden: false })
  //     this.setState({ deliveredDtIsHidden: false })
  //     this.setState({ equipmentIsHidden: false })
  //     this.setState({ parMachineTypeIsHidden: false })
  //     this.setState({ maskTypeIsHidden: false })
  //     this.setState({ orderStatusIsHidden: true })
  //     this.setState({ orderNoteIsHidden: true })
  //   }
  //   else {
  //     this.setState({ pt_PhoneNumberIsHidden: true })
  //     this.setState({ pt_MobileNumberIsHidden: true })
  //     this.setState({ compliancePctIsHidden: true })
  //     this.setState({ daysSinceSetupIsHidden: true })
  //     this.setState({ compliantDaysSinceSetupIsHidden: true })
  //     this.setState({ isClickedIsHidden: true })
  //     this.setState({ soCreateDtIsHidden: true })
  //     this.setState({ deliveredDtIsHidden: true })
  //     this.setState({ equipmentIsHidden: true })
  //     this.setState({ parMachineTypeIsHidden: true })
  //     this.setState({ maskTypeIsHidden: true })
  //     this.setState({ orderStatusIsHidden: false })
  //     this.setState({ orderNoteIsHidden: false })
  //   }
  //   //this.setState({ orderStatus })
  //   this.setState({ isVisible: false })
  //   this.setState({ isVisibleCompliance: false })
  //   this.setState({ statusParam: localStorage.getItem('legendNameAdherenceBreakDowns') == "30 Days" ? "30 Days" : localStorage.getItem('legendNameAdherenceBreakDowns') == "60 Days" ? "60 Days" : localStorage.getItem('legendNameAdherenceBreakDowns') == "90 Days" ? "90 Days" : "" })
  //   this.setState({ complianceRiskParam: localStorage.getItem('legendNameAdherenceBreakDowns') == "Below 70% Compliance" ? "Critical,Low,Moderate" : localStorage.getItem('legendNameAdherenceBreakDowns') == "Above 70% Compliance" ? "Compliant" : "" })
  //   this.props.fetchSalesOrderFilterListRequest({
  //     "statusParam": localStorage.getItem('legendNameAdherenceBreakDowns') == "30 Days" ? "30 Days" : localStorage.getItem('legendNameAdherenceBreakDowns') == "60 Days" ? "60 Days" : localStorage.getItem('legendNameAdherenceBreakDowns') == "90 Days" ? "90 Days" : "",
  //     "salesRepParam": "",
  //     "doctorParam": "",
  //     "doctorNameParam": "",
  //     "doctorFirstNameParam": "",
  //     "doctorLastNameParam": "",
  //     "insuranceParam": "",
  //     "maskTypeParam": "",
  //     "complianceRiskParam": localStorage.getItem('legendNameAdherenceBreakDowns') == "Below 70% Compliance" ? "Critical,Low,Moderate" : localStorage.getItem('legendNameAdherenceBreakDowns') == "Above 70% Compliance" ? "Compliant" : "",
  //     "equipmentTypeParam": "",
  //     "daysSinceSetupParam": "",
  //     "organizationParam": this.props.organizationParam,
  //     "referralParam": this.props.referralParam,
  //     // "limitParam": "10000",
  //     "startDate": "",
  //     "endDate": "",
  //     "patientNameParam": "",
  //     "patientFirstNameParam": "",
  //     "patientNameLastParam": "",
  //     "dateOfBirthParam": "",
  //     // "rowsToSkip": "0",
  //     "orderByFieldParam": "OrderStatus",
  //     "sortOrderParam": "asc",
  //     "PageSize": this.state.rowsPerPage,
  //     "PageNo": 0,
  //   });
  //   let salesFilterList = []
  //   salesFilterList.push({ name: localStorage.getItem('legendNameAdherenceBreakDowns').includes("Compliance") ? 'Compliance Status' : 'Order Status', value: localStorage.getItem('legendNameAdherenceBreakDowns') })
  //   this.props.saveSalesFilter(salesFilterList, true)

  //   localStorage.removeItem('legendNameAdherenceBreakDowns');
  // }

  // if (localStorage.getItem('legendNameNonPapOrdereBreakDowns') != null) {
  //   this.setState({ panel3: 'panel3' });
  //   window.scrollTo({
  //     top: this.state.salesOrderDiv.current.offsetTop,
  //     behavior: 'smooth'
  //   })
  //   this.setState({ isLoading: true });
  //   this.setState({ statusParam: localStorage.getItem('legendNameNonPapOrdereBreakDowns') })
  //   this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
  //     ReferralParam: this.props.referralParam,
  //     IsStatusNameParam: true,
  //     StatusNameParam: localStorage.getItem('legendNameNonPapOrdereBreakDowns')
  //   });
  //   let salesFilterList = []
  //   salesFilterList.push({ name: 'Order Status', value: localStorage.getItem('legendNameNonPapOrdereBreakDowns') })
  //   this.props.saveSalesFilter(salesFilterList, true)

  //   localStorage.removeItem('legendNameNonPapOrdereBreakDowns');
  // }
  // }, 1000);
  // }

  handleChange = (panel) => (event, newExpanded) => {
    this.setState({ [panel]: newExpanded ? panel : false });
  };

  handleAdherenceBreakdownsChange = (e) => {
    this.setState({ isChangeChartDdl: true });
    this.setState({ ddlSelectedOption: e.target.value })
    this.props.fetchAdherenceBreakdownDetailRequest({ Type: e.target.value })
    this.setState({ isLoadingAdherenceBreakdownsChartByOption: true });
  }
  displayAlert = (title, message, type) => {
    if (type == 'success') {
      this.setState({
        alert: < SweetAlert
          success
          title={title}
          onConfirm={() => this.hideModel()} >
          {message}
        </SweetAlert>,
        showModal: !this.state.showModal,
      })
    }
    //else if (type = 'info') {
    //    this.setState({
    //        alert: < SweetAlert
    //            title={title}
    //            onConfirm={() => this.hideModel()} >
    //            {message}
    //        </SweetAlert>,
    //        showModal: !this.state.showModal,
    //    })
    //}
    else {
      this.setState({
        alert: < SweetAlert
          error
          title={title}
          onConfirm={() => this.hideModel()} >
          {message}
        </SweetAlert>,
        showModal: !this.state.showModal,
      })
    }
  }

  hideModel = () => {
    this.setState({ alert: '', showModal: false })
  }

  enableLoading = () => {
    this.setState({ isLoading: true });
  }

  disableLoading = () => {
    setTimeout(function () {
      this.setState({ isLoading: false });
    }.bind(this), 3000)
  }

  changePage = async (event) => {
    this.enableLoading();
    await this.setState({ currentPage: event });
    this.disableLoading();

  }
  changeOrderByNonPap = async (orderedColumnId, orderDirection) => {
    // currentSortOrderNonPap
    let columns = {
      0: 'patientName',
      1: 'physician',
      2: 'dob',
      3: 'phone',
    }
    let sortBy = orderedColumnId >= 0 ? columns[orderedColumnId] : columns[0]
    orderDirection = orderDirection ? orderDirection : 'asc'
    this.setState({ sortByNonPap: sortBy, currentSortOrderNonPap: { defaultSort: orderDirection } })
  }


  changeOrderByPap = async (orderedColumnId, orderDirection) => {
    this.enableLoading();
    let columns = {
      0: 'patientName',
      1: 'dob',
      2: 'pt_PhoneNumber',
      3: 'pt_MobileNumber',
      4: 'risk',
      5: 'daysSinceSetup',
      6: 'compliantDaysSinceSetup',
      7: 'equipment',
      8: 'soCreateDt',
      9: 'deliveredDt',
      10: 'equipment',
      11: 'parMachineType',
      12: 'maskType',
      13: 'OrderStatus',
      14: 'orderNote',
      15: 'doctorName'
    }
    let sortBy = orderedColumnId >= 0 ? columns[orderedColumnId] : columns[13]
    orderDirection = orderDirection ? orderDirection : 'asc';
    this.setState({ sortBy: sortBy, currentSortOrderPap: { defaultSort: orderDirection } });
    this.disableLoading();
  }

  handleTooltipClose = () => {
    this.setState({ showFilter: false });
  };

  handleToggleTooltip = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };
  handleResetFilter = () => {
    //localStorage.setItem('newReferralParamForPieChartSelection', '');
    this.setState({ isLoading: true });
    this.props.clearFilter({
      "isFilterClear": true,
    });
    this.props.saveSalesFilter([], true)
    this.setState({ pt_PhoneNumberIsHidden: true })
    this.setState({ pt_MobileNumberIsHidden: true })
    this.setState({ compliancePctIsHidden: true })
    this.setState({ daysSinceSetupIsHidden: true })
    this.setState({ compliantDaysSinceSetupIsHidden: true })
    this.setState({ isClickedIsHidden: true })
    this.setState({ soCreateDtIsHidden: true })
    this.setState({ deliveredDtIsHidden: true })
    this.setState({ equipmentIsHidden: true })
    this.setState({ parMachineTypeIsHidden: true })
    this.setState({ maskTypeIsHidden: true })
    this.setState({ orderStatusIsHidden: false })
    this.setState({ orderNoteIsHidden: false })
    if (this.props.isPapUser == 1) {
      this.props.fetchSalesOrderFilterListRequest({
        "statusParam": "",
        "salesRepParam": "",
        "doctorParam": "",
        "doctorNameParam": "",
        "doctorFirstNameParam": "",
        "doctorLastNameParam": "",
        "insuranceParam": "",
        "maskTypeParam": "",
        "complianceRiskParam": "",
        "equipmentTypeParam": "",
        "daysSinceSetupParam": "",
        "organizationParam": this.props.organizationParam,
        "referralParam": localStorage.getItem('newReferralParamForPieChartSelection') == '' ? this.props.referralParam : localStorage.getItem('newReferralParamForPieChartSelection'),
        // "limitParam": "10000",
        "startDate": "",
        "endDate": "",
        "patientNameParam": "",
        "patientFirstNameParam": "",
        "patientNameLastParam": "",
        "dateOfBirthParam": "",
        // "rowsToSkip": "0",
        "orderByFieldParam": "OrderStatus",
        "sortOrderParam": "asc",
        "PageSize": this.state.rowsPerPage,
        "PageNo": this.state.currentPage
      });
    }
    else {
      this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
        ReferralParam: JSON.parse(localStorage.getItem('persist:userData')).referralParam.replace(/"/g, ''),
        IsStatusNameParam: false,
        StatusNameParam: ""
      });
    }
  }

  changeRowsPerPage = async (event) => {
    await this.setState({ rowsPerPage: event });
    this.enableLoading();
    this.disableLoading();
  }

  scrollToSalesList = (salesFilter) => {
    // this.state.salesOrderDiv.current.scrollIntoView()
    this.setState({ panel3: 'panel3' });
    window.scrollTo({
      top: this.state.salesOrderDiv.current.offsetTop,
      behavior: 'smooth'
    })
    this.props.saveSalesFilter(salesFilter, false)
  }
  toggle = (ptKey, rowdata) => {
    this.setState({ isLoadingNonPapPopover: true })
    this.props.fetchSalesOrderFilterListAdherenceInfoRequest({
      ptKey: ptKey
    });
    this.setState({ popoverOpen: true });
    this.setState({ selectedPtKey: rowdata.rowId });
  }

  outsideClick = () => {
    this.setState({ popoverOpen: false });
    this.setState({ selectedPtKey: 0 });
  }


  toggleNonPap = (patientName) => {
      if (this.state.descPopoverOpen)
        this.setState({ descPopoverOpen: !this.state.descPopoverOpen, });
    this.setState({ isLoadingNonPapPopover: true })
    this.props.fetchNonPAPPatientDetailRequest({
      PatientNameParam: patientName,
      ReferralKey: this.props.referralParam
    });
    this.setState({ popoverOpen: true });
    this.setState({ selectedPatientName: patientName.replace(/[^a-zA-Z]/g, "") });
  }
  patientDetailHeaderClick = async (isPatientDetailPopup) => {
    if(isPatientDetailPopup){
      this.setState({showPatientDetails : true});
      this.setState({showPatientNotes : false});
    }
    else{
      this.setState({showPatientDetails : false});
      this.setState({showPatientNotes : true});
    }
  }

  patientNoteExpand = async (isPatientDetailPopup, patientNoteId) => {
      if(isPatientDetailPopup){
        this.setState({ expandPatientNoteFor: this.state.expandPatientNoteFor == patientNoteId ? '' : patientNoteId});
      }
  }

  outsideClickNonPap = () => {
    this.setState({ popoverOpen: false });
    this.setState({ selectedPatientName: '' });
    this.setState({ expandPatientNoteFor: '' });
    this.setState({showPatientDetails : true});
      this.setState({showPatientNotes : false});
  }

  showTrackingNumber = async (data) => {
    window.open(data.trackingNbr, "_blank")
  }

  handleResmedSummaryDocument = async (data) => {
    this.setState({ isLoadingDocument: true })
    // this.props.fetchResmedSummaryDocRequest(data)
    const options = {
      params: {
        "Days": data.days,
        "PatientIdFlag": data.airviewFlag
      },
    };
    await axiosAPI.get('/dashboard/getresmedsummarydocument', options)
      .then((response) => {
        if (response.data.success && response.data.documentPath) {
          var userId = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).userId;
          var AccessToken = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user).accessToken;
          if (userId != '' && AccessToken)
            window.open(process.env.REACT_APP_API_IMAGE_URL + response.data.documentPath + "?userid=" + userId + "&token=" + AccessToken, "_blank");
          else
            this.displayAlert(response.data.message, '', 'error')
        } else {
          this.displayAlert(response.data.message, '', 'error')
        }
      })
    this.setState({ isLoadingDocument: false })
  }
  get_hidden_string = (name) => {
    let return_name = '';
    let explode = name.split(', ');
    let name_length = explode[0].length
    if (explode[0] && explode[0].length > 3) {
      return_name += explode[0] && explode[0].length > 3 ? explode[0].substr(0, 3) + '*'.repeat(name_length - 3) : '';
    } else {
      return_name += explode[0] && explode[0].length <= 3 ? explode[0].substr(0, 2) + '*'.repeat(name_length - 2) : '';
    }
    return_name += ', ';
    //        return_name += isset(explode[1]) && strlen(explode[1]) > 3 ? substr(explode[1], 0, 3) . str_repeat("*", strlen(explode[1]) - 3) : '';
    return_name += explode[1] ? explode[1] : '';
    return return_name;
  }
  handleEncoreSummaryDocument = async (data) => {
	this.setState({ isLoadingDocument: true })
    // this.props.fetchResmedSummaryDocRequest(data)
    const options = {
      params: {
        "Days": data.days,
        "PatientIdFlag": data.encoreFlag
      },
    };
    await axiosAPI.get('/dashboard/getphillipsummarydocument', options)
      .then((response) => {
        if (response.data.success && response.data.documentPath) {
          window.open(process.env.REACT_APP_API_IMAGE_URL + response.data.documentPath, "_blank")
        } else {
          this.displayAlert(response.data.message, '', 'error')
        }
      })
	this.setState({ isLoadingDocument: false })
  }
  loadLegendNameOrdereBreakDowns = (legendNameOrdereBreakDowns) => {
    if (legendNameOrdereBreakDowns != null) {
      this.setState({ panel3: 'panel3' });
      window.scrollTo({
        top: this.state.salesOrderDiv.current.offsetTop,
        behavior: 'smooth'
      })
      this.setState({
        isLoading: true,
        currentPage: 0,
        isClicked: false,
      });
      // this.setState({ isLoading: true });
      // this.setState({ currentPage: 0 });
      // this.setState({ isClicked: false })

      if (legendNameOrdereBreakDowns == "Delivered") {
        this.setState({
          pt_PhoneNumberIsHidden: true,
          pt_MobileNumberIsHidden: true,
          compliancePctIsHidden: true,
          daysSinceSetupIsHidden: true,
          compliantDaysSinceSetupIsHidden: true,
          isClickedIsHidden: true,
          soCreateDtIsHidden: false,
          deliveredDtIsHidden: false,
          equipmentIsHidden: false,
          parMachineTypeIsHidden: false,
          maskTypeIsHidden: false,
          orderStatusIsHidden: false,
          orderNoteIsHidden: true,
        })
        // this.setState({ pt_PhoneNumberIsHidden: true })
        // this.setState({ pt_MobileNumberIsHidden: true })
        // this.setState({ compliancePctIsHidden: true })
        // this.setState({ daysSinceSetupIsHidden: true })
        // this.setState({ compliantDaysSinceSetupIsHidden: true })
        // this.setState({ isClickedIsHidden: true })
        // this.setState({ soCreateDtIsHidden: false })
        // this.setState({ deliveredDtIsHidden: false })
        // this.setState({ equipmentIsHidden: false })
        // this.setState({ parMachineTypeIsHidden: false })
        // this.setState({ maskTypeIsHidden: false })
        // this.setState({ orderStatusIsHidden: false })
        // this.setState({ orderNoteIsHidden: true })
      }
      else {
        this.setState({
          pt_PhoneNumberIsHidden: true,
          pt_MobileNumberIsHidden: true,
          compliancePctIsHidden: true,
          daysSinceSetupIsHidden: true,
          compliantDaysSinceSetupIsHidden: true,
          isClickedIsHidden: true,
          soCreateDtIsHidden: true,
          deliveredDtIsHidden: true,
          equipmentIsHidden: true,
          parMachineTypeIsHidden: true,
          maskTypeIsHidden: true,
          orderStatusIsHidden: false,
          orderNoteIsHidden: false,
        })

        // this.setState({ pt_PhoneNumberIsHidden: true })
        // this.setState({ pt_MobileNumberIsHidden: true })
        // this.setState({ compliancePctIsHidden: true })
        // this.setState({ daysSinceSetupIsHidden: true })
        // this.setState({ compliantDaysSinceSetupIsHidden: true })
        // this.setState({ isClickedIsHidden: true })
        // this.setState({ soCreateDtIsHidden: true })
        // this.setState({ deliveredDtIsHidden: true })
        // this.setState({ equipmentIsHidden: true })
        // this.setState({ parMachineTypeIsHidden: true })
        // this.setState({ maskTypeIsHidden: true })
        // this.setState({ orderStatusIsHidden: false })
        // this.setState({ orderNoteIsHidden: false })
      }
      this.setState({ statusParam: legendNameOrdereBreakDowns })
      this.props.fetchSalesOrderFilterListRequest({
        "statusParam": legendNameOrdereBreakDowns,
        "salesRepParam": "",
        "doctorParam": "",
        "doctorNameParam": "",
        "doctorFirstNameParam": "",
        "doctorLastNameParam": "",
        "insuranceParam": "",
        "maskTypeParam": "",
        "complianceRiskParam": "",
        "equipmentTypeParam": "",
        "daysSinceSetupParam": "",
        "organizationParam": this.props.organizationParam,
        "referralParam": localStorage.getItem('newReferralParamForPieChartSelection') == '' ? this.props.referralParam : localStorage.getItem('newReferralParamForPieChartSelection'),
        // "limitParam": "10000",
        "startDate": "",
        "endDate": "",
        "patientNameParam": "",
        "patientFirstNameParam": "",
        "patientNameLastParam": "",
        "dateOfBirthParam": "",
        // "rowsToSkip": "0",
        "orderByFieldParam": "OrderStatus",
        "sortOrderParam": "asc",
        "PageSize": this.state.rowsPerPage,
        "PageNo": 0,
      });

      let salesFilterList = []
      salesFilterList.push({ name: 'Order Status', value: legendNameOrdereBreakDowns })
      this.props.saveSalesFilter(salesFilterList, true)
    }
  }

  loadLegendNameAdherenceBreakDowns = (legendNameAdherenceBreakDowns) => {
    if (legendNameAdherenceBreakDowns != null) {
      this.setState({ panel3: 'panel3' });
      window.scrollTo({
        top: this.state.salesOrderDiv.current.offsetTop,
        behavior: 'smooth'
      })

      this.setState({
        isLoading: true,
        currentPage: 0,
        isClicked: true,
      });
      // this.setState({ isLoading: true });
      // this.setState({ currentPage: 0 });
      // this.setState({ isClicked: true });

      if (this.state.ddlSelectedOption == "By Adherence Status" || "By Device") {
        this.setState({
          pt_PhoneNumberIsHidden: false,
          pt_MobileNumberIsHidden: false,
          compliancePctIsHidden: false,
          daysSinceSetupIsHidden: false,
          compliantDaysSinceSetupIsHidden: false,
          isClickedIsHidden: false,
          soCreateDtIsHidden: false,
          deliveredDtIsHidden: false,
          equipmentIsHidden: false,
          parMachineTypeIsHidden: false,
          maskTypeIsHidden: false,
          orderStatusIsHidden: true,
          orderNoteIsHidden: true,
        })

        // this.setState({ pt_PhoneNumberIsHidden: false })
        // this.setState({ pt_MobileNumberIsHidden: false, })
        // this.setState({ compliancePctIsHidden: false, })
        // this.setState({ daysSinceSetupIsHidden: false, })
        // this.setState({ compliantDaysSinceSetupIsHidden: false, })
        // this.setState({ isClickedIsHidden: false, })
        // this.setState({ soCreateDtIsHidden: false, })
        // this.setState({ deliveredDtIsHidden: false, })
        // this.setState({ equipmentIsHidden: false, })
        // this.setState({ parMachineTypeIsHidden: false, })
        // this.setState({ maskTypeIsHidden: false, })
        // this.setState({ orderStatusIsHidden: true, })
        // this.setState({ orderNoteIsHidden: true, })
      }
      else {
        this.setState({
          pt_PhoneNumberIsHidden: true,
          pt_MobileNumberIsHidden: true,
          compliancePctIsHidden: true,
          daysSinceSetupIsHidden: true,
          compliantDaysSinceSetupIsHidden: true,
          isClickedIsHidden: true,
          soCreateDtIsHidden: true,
          deliveredDtIsHidden: true,
          equipmentIsHidden: true,
          parMachineTypeIsHidden: true,
          maskTypeIsHidden: true,
          orderStatusIsHidden: false,
          orderNoteIsHidden: false,
        })

        // this.setState({ pt_PhoneNumberIsHidden:, true })
        // this.setState({ pt_MobileNumberIsHidden: true, })
        // this.setState({ compliancePctIsHidden: true, })
        // this.setState({ daysSinceSetupIsHidden: true, })
        // this.setState({ compliantDaysSinceSetupIsHidden: true, })
        // this.setState({ isClickedIsHidden: true, })
        // this.setState({ soCreateDtIsHidden: true, })
        // this.setState({ deliveredDtIsHidden: true, })
        // this.setState({ equipmentIsHidden: true, })
        // this.setState({ parMachineTypeIsHidden: true, })
        // this.setState({ maskTypeIsHidden: true, })
        // this.setState({ orderStatusIsHidden: false, })
        // this.setState({ orderNoteIsHidden: false, })
      }

      this.setState({
        isVisible: false,
        isVisibleCompliance: false,
        statusParam: legendNameAdherenceBreakDowns == "30 Days" ? "30 Days" : legendNameAdherenceBreakDowns == "60 Days" ? "60 Days" : legendNameAdherenceBreakDowns == "90 Days" ? "90 Days" : "",
        complianceRiskParam: legendNameAdherenceBreakDowns == "Below 70% Compliance" ? "Critical,Low,Moderate" : legendNameAdherenceBreakDowns == "Above 70% Compliance" ? "Compliant" : ""
      })

      // this.setState({ isVisibleCompliance: false })
      // this.setState({ statusParam: legendNameAdherenceBreakDowns == "30 Days" ? "30 Days" : legendNameAdherenceBreakDowns == "60 Days" ? "60 Days" : legendNameAdherenceBreakDowns == "90 Days" ? "90 Days" : "" })
      // this.setState({ complianceRiskParam: legendNameAdherenceBreakDowns == "Below 70% Compliance" ? "Critical,Low,Moderate" : legendNameAdherenceBreakDowns == "Above 70% Compliance" ? "Compliant" : "" })

      //this.setState({ orderStatus })
      // this.setState({ isVisible: false })
      // this.setState({ isVisibleCompliance: false })
      // this.setState({ statusParam: legendNameAdherenceBreakDowns == "30 Days" ? "30 Days" : legendNameAdherenceBreakDowns == "60 Days" ? "60 Days" : legendNameAdherenceBreakDowns == "90 Days" ? "90 Days" : "" })
      // this.setState({ complianceRiskParam: legendNameAdherenceBreakDowns == "Below 70% Compliance" ? "Critical,Low,Moderate" : legendNameAdherenceBreakDowns == "Above 70% Compliance" ? "Compliant" : "" })
      this.props.fetchSalesOrderFilterListRequest({
        "statusParam": legendNameAdherenceBreakDowns == "30 Days" ? "30 Days" : legendNameAdherenceBreakDowns == "60 Days" ? "60 Days" : legendNameAdherenceBreakDowns == "90 Days" ? "90 Days" : "",
        "salesRepParam": "",
        "doctorParam": "",
        "doctorNameParam": "",
        "doctorFirstNameParam": "",
        "doctorLastNameParam": "",
        "insuranceParam": "",
        "maskTypeParam": "",
        "complianceRiskParam": legendNameAdherenceBreakDowns == "Below 70% Compliance" ? "Critical,Low,Moderate" : legendNameAdherenceBreakDowns == "Above 70% Compliance" ? "Compliant" : "",
        "equipmentTypeParam": "",
        "daysSinceSetupParam": "",
        "organizationParam": this.props.organizationParam,
        "referralParam": localStorage.getItem('newReferralParamForPieChartSelection') == '' ? this.props.referralParam : localStorage.getItem('newReferralParamForPieChartSelection'),
        // "limitParam": "10000",
        "startDate": "",
        "endDate": "",
        "patientNameParam": "",
        "patientFirstNameParam": "",
        "patientNameLastParam": "",
        "dateOfBirthParam": "",
        // "rowsToSkip": "0",
        "orderByFieldParam": "OrderStatus",
        "sortOrderParam": "asc",
        "PageSize": this.state.rowsPerPage,
        "PageNo": 0,
      });
      let salesFilterList = []
      salesFilterList.push({ name: legendNameAdherenceBreakDowns.includes("Compliance") ? 'Compliance Status' : 'Order Status', value: legendNameAdherenceBreakDowns })
      this.props.saveSalesFilter(salesFilterList, true)
    }
  }

  loadLegendNameNonPapOrdereBreakDowns = (legendNameNonPapOrdereBreakDowns) => {
    if (legendNameNonPapOrdereBreakDowns != null) {
      this.setState({ panel3: 'panel3' });
      window.scrollTo({
        top: this.state.salesOrderDiv.current.offsetTop,
        behavior: 'smooth'
      })
      this.setState({ isLoading: true });
      this.setState({ statusParam: legendNameNonPapOrdereBreakDowns })
      this.props.fetchNonPAPSalesOrderDetailsListByStatusRequest({
        ReferralParam: localStorage.getItem('newReferralParamForPieChartSelection') == '' ? this.props.referralParam : localStorage.getItem('newReferralParamForPieChartSelection'),
        IsStatusNameParam: true,
        StatusNameParam: legendNameNonPapOrdereBreakDowns
      });
      let salesFilterList = []
      salesFilterList.push({ name: 'Order Status', value: legendNameNonPapOrdereBreakDowns })
      this.props.saveSalesFilter(salesFilterList, true)
    }
  }

  hideShowLeftDashboardMenu = () => {
    this.setState({
      isLeftMenuVisible: !this.state.isLeftMenuVisible
    })
  }

  // scrollToBreakDown = (divIdToScroll) => {
  //   // document.getElementById(divIdToScroll).scrollIntoView({behavior: 'smooth'});
  //   var activClassJson = {
  //     breakdownClass: '',
  //     trendsClass: '',
  //     detailsClass: '',
  //   };

  //   if (divIdToScroll == 'breakdown') {
  //     activClassJson.breakdownClass = 'active';
  //   }
  //   else if (divIdToScroll == 'trends') {
  //     activClassJson.trendsClass = 'active';
  //   }
  //   else {
  //     activClassJson.detailsClass = 'active';
  //   }
  //   this.setState(activClassJson);

  //   var element = document.getElementById(divIdToScroll);
  //   if (element) {
  //     const offset = document.getElementsByTagName("header")[0].offsetHeight;
  //     const bodyRect = document.body.getBoundingClientRect().top;
  //     const elementRect = element.getBoundingClientRect().top;
  //     const elementPosition = elementRect - bodyRect;
  //     const offsetPosition = elementPosition - (offset);

  //     window.scrollTo({
  //       top: offsetPosition,
  //       behavior: 'smooth'
  //     });
  //     // var headerOffset = 70;
  //     // var headerEle = document.getElementsByTagName("header")[0];
  //     // var elementPosition = element.getBoundingClientRect().top;
  //     // var offsetPosition = elementPosition - headerEle.offsetHeight;

  //     // window.scrollTo({
  //     //   top: offsetPosition,
  //     //   behavior: "smooth"
  //     // });
  //     // element.scrollIntoView({behavior: "smooth"})
  //   }
  // }
  scrollToBreakDown = (divIdToScroll) => {
    // document.getElementById(divIdToScroll).scrollIntoView({behavior: 'smooth'});
    var activClassJson = {
      breakdownClass: '',
      trendsClass: '',
      detailsClass: '',
    };

    if (divIdToScroll == 'breakdown') {
      activClassJson.breakdownClass = 'active';
    }
    else if (divIdToScroll == 'trends') {
      activClassJson.trendsClass = 'active';
    }
    else {
      activClassJson.detailsClass = 'active';
    }
    this.setState(activClassJson);

    const element = document.getElementById(divIdToScroll);
    if (element) {
      const offset = 45;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - (offset + 35);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  render() {
    var checkC = color != undefined ? JSON.parse(JSON.stringify(color).replace(/}}/g, '}').replace(/}]/g, '}}').replace("[{", "{").replace(/,{/g, ',')) : "";
    this.state.chart = this.props.chartData;
    this.state.chartDeliveredUndelivered = this.props.chartDataDeliveredUndelivered;
    this.state.totalRecords = this.props.totalRecords;
    this.state.list = this.props.userData;
    this.state.popover = this.props.userDataAdherenceInfo;
    this.state.orderBreakDown = this.props.dashboardDetailsOrderBreakDown;
    this.state.adherenceBreakDown = this.state.isChangeChartDdl == true ? this.props.adherenceBreakdownDetail : this.props.dashboardDetailsAdherenceBreakDown;
    this.state.nonPapOrderBreakDown = this.props.nonPAPDashboardDetails;
    this.state.chartNonPapDeliveredUndelivered = this.props.chartNonPapDataDeliveredUndelivered;
    let popoverNonPap = [...this.props.nonPAPPatientDetail];
    let patientNoteList = [...this.props.patientNoteList];
    let liCancelledOrderResponse = [...this.props.liCancelledOrderResponse];
    let liOutsourcedOrderResponse = [...this.props.liOutsourcedOrderResponse];
    let isInternalRole = this.props.isInternalRole;

    var colors = {
      'Processing': '#5867dd',
      'Delivered': '#34bfa3',
      'Voided': '#c4c5d6',
      'Scheduling': '#28a745',
      'Authorization':'#ffb822',
      'Scheduling Unsuccessful': '#f4516c',
      'Pending Authorization': '#5867dd',
      'Success': '#34bfa3',
      'Ready For Delivery': '#36a3f7',
      'Delivery Unsuccessful': '#f4516c',
      'Error': '#f4516c',
      'Attempting Reschedule': '#FD7E14',
      'Cancelled': '#f4516c',
      'Held For Processing': '#ffb822',
      'Shipped': '#34bfa3',
      'In Process': '#5867dd',
      'In Process - Backorder': '#5867dd',
      'In Process - Scheduled Order': '#5867dd',
      'On Hold': '#5867dd',
      'Order Cancelled': '#f4516c',
      'Order Cancelled - Authorization Not Approved': '#f4516c',
      'Order Cancelled - Canceled per Doc Policy': '#f4516c',
      'Order Cancelled - Eligibility Issue': '#f4516c',
      'Order Cancelled - Insufficient Medical Documents': '#f4516c',
      'Order Cancelled - Insufficient Patient Documents': '#f4516c',
      'Order Cancelled - No Response from Sales Rep': '#f4516c',
      'Order Cancelled - Non-Covered Items': '#f4516c',
      'Order Cancelled - Non-Participating Payer': '#f4516c',
      'Order Cancelled - Order Cancelled Before Shipment': '#f4516c',
      'Order Cancelled - Order Created in Error': '#f4516c',
      'Order Cancelled - Order Created Previously': '#f4516c',
      'Order Cancelled - Outsourced Order': '#f4516c',
      'Order Cancelled - ParachuteHealth': '#f4516c',
      'Order Cancelled - Patient - OOP Cost': '#f4516c',
      'Order Cancelled - Patient Cancelled Order': '#f4516c',
      'Order Cancelled - Patient Deceased': '#f4516c',
      'Order Cancelled - Patient Never Responded': '#f4516c',
      'Order Cancelled - Referral Cancelled Order': '#f4516c',
      'Order Cancelled - Reorder too soon (Order Exceeds 14 Days)': '#f4516c',
      'Order Cancelled - RRB Created in Error': '#f4516c',
      'Order Cancelled - Wound Care Rekey': '#f4516c',
      'Pending - Authorization Needed': '#5867dd',
      'Pending - Documentation Needed': '#5867dd',
      'Pending - Information Needed': '#5867dd',
      'Pending - Authorization': '#5867dd',
      'Pending - Authorization Needed': '#5867dd',
      'Pending - Documentation Needed': '#5867dd',
      'Pending - Information Needed': '#5867dd',
    };

    // let orderBreakDownChart = ["", "", ""];
    let orderBreakDownChart = [
      ['Order Status', 'Totals', 'style'],
    ]
    let filterOrderBreakDownCard = [];
    if (this.state.orderBreakDown !== null && this.state.orderBreakDown !== undefined && this.state.orderBreakDown.length > 0) {
      orderBreakDownChart = [
        ['Order Status', 'Totals', 'style'],
      ]
      this.state.orderBreakDown = this.state.orderBreakDown.sort((a, b) => (a.total < b.total) ? 1 : -1);
      this.state.orderBreakDown.forEach((field) => {
        orderBreakDownChart.push([
          field.orderStatus || "",
          field.total || 0,
          colors[field.orderStatus] || ""
        ]);
        if (field.total > 0) {
          filterOrderBreakDownCard.push(field.orderStatus);
        }
      });
      localStorage.setItem("FullOrderBreakdowns", JSON.stringify(orderBreakDownChart));
      var data = JSON.parse(localStorage.getItem('FullOrderBreakdowns'));
        data = data.map((value, key) => {
        return { [key - 1]: { color: value[2] } }
      })
      var color = data.splice(1, data.length);
    } else if (this.props.dashboardDetailsOrderBreakDownLoading === false) {
      orderBreakDownChart = [
        ['Order Status', 'Totals', 'style'],
      ]
    }

    let adherenceBreakDownChart = [
      ['Adherence Status', 'Totals'],
    ]
    let filterAdherenceBreakDownChart = [];
    if (this.state.adherenceBreakDown !== null && this.state.adherenceBreakDown !== undefined && this.state.adherenceBreakDown.length > 0) {

      if (this.state.ddlSelectedOption === "by_time_period") {
        adherenceBreakDownChart = [
          ['Adherence Status', 'Totals'],
        ]
        this.state.adherenceBreakDown.forEach((field) => {
          adherenceBreakDownChart.push([
            "30 Days",
            field.averageAdherence30
          ]);
          filterAdherenceBreakDownChart.push("30 Days");
          adherenceBreakDownChart.push([
            "60 Days",
            field.averageAdherence60
          ]);
          filterAdherenceBreakDownChart.push("60 Days");
          adherenceBreakDownChart.push([
            "90 Days",
            field.averageAdherence90
          ]);
          filterAdherenceBreakDownChart.push("90 Days");
        });
      } else {
        adherenceBreakDownChart = [
          ['Adherence Status', 'Totals'],
        ]
        this.state.adherenceBreakDown.forEach((field) => {
          adherenceBreakDownChart.push([
            field.risk || "",
            field.totals || 0,
          ]);
          filterAdherenceBreakDownChart.push(field.risk);
        });
      }
      localStorage.setItem("AdherenceBreakDowns", JSON.stringify(adherenceBreakDownChart));
    } else if (this.props.dashboardDetailsOrderBreakDownLoading === false) {
      adherenceBreakDownChart = [
        ['Adherence Status', 'Totals'],
      ]
    }

    //let nonPapOrderBreakDownChart = ["", ""];
    let nonPapOrderBreakDownChart = [
      ['Order Status', 'Totals'],
    ]
    if (this.state.nonPapOrderBreakDown !== null && this.state.nonPapOrderBreakDown !== undefined && this.state.nonPapOrderBreakDown.length > 0) {
      nonPapOrderBreakDownChart = [
        ['Order Status', 'Totals'],
      ]
      this.state.nonPapOrderBreakDown = this.state.nonPapOrderBreakDown.sort((a, b) => (a.total < b.total) ? 1 : -1);
      this.state.nonPapOrderBreakDown.forEach((field) => {
        nonPapOrderBreakDownChart.push([
          field.orderStatus || "",
          field.total || 0,
        ]);
      });
      localStorage.setItem("nonPapFullOrderBreakDowns", JSON.stringify(nonPapOrderBreakDownChart));
    } else if (this.props.nonPAPDashboardDetailsLoading === false) {
      nonPapOrderBreakDownChart = [
        ['Order Status', 'Totals'],
      ]
    }

    // let deliveryStatusChart = [["date-month", '' , '']];
    let deliveryStatusChart = [
      ['date-month', 'Delivered', 'Undelivered'],
    ]
    if (this.state.chartDeliveredUndelivered !== null && this.state.chartDeliveredUndelivered !== undefined && this.state.chartDeliveredUndelivered.length > 0) {
      deliveryStatusChart = [];
      var tempDeliveryStatusChart = [];
      this.state.chartDeliveredUndelivered.forEach((field) => {
        tempDeliveryStatusChart.push([
          new Date(field.deliveredOrderYear == 0 ? field.unDeliveredOrderYear : field.deliveredOrderYear, (field.deliveredOrderMonth == 0 ? field.unDeliveredOrderMonth : field.deliveredOrderMonth) - 1, (field.deliveredOrderDay == 0 ? field.unDeliveredOrderDay : field.deliveredOrderDay), 0, 0, 0, 0),
          field.deliveredTotal || 0,
          field.unDeliveredTotal || 0,
        ]);
      });

      tempDeliveryStatusChart = tempDeliveryStatusChart.sort(function (a, b) {
        if (a[0] < b[0]) {
          return -1;
        }
        if (b[0] < a[0]) {
          return 1;
        }
        return 0;
      });
      tempDeliveryStatusChart.forEach((field) => {
        deliveryStatusChart.push([
          field[0].toLocaleString('en-el', { day: '2-digit', month: 'short' }),
          field[1] || 0,
          field[2] || 0,
        ]);
      });

      deliveryStatusChart.unshift(['date-month', 'Delivered', 'Undelivered']);
    }
    else if (this.props.chartDataLoading == false && deliveryStatusChart.length == 1) {
      for (let i = 2; i > 0; i--) {
        let d = new Date((new Date()).setMonth((new Date()).getMonth() - i));
        let isData = false;
        deliveryStatusChart.push([
          new Date(d).toLocaleString('en-el', { day: '2-digit', month: 'short' }),
          0,
          0
        ]);
      }
    }

    // let nonPapDeliveryStatusChart = [['month','' ,'']];
    let nonPapDeliveryStatusChart = [
      ['date-month', 'Delivered', 'Undelivered'],
    ]
    if (this.state.chartNonPapDeliveredUndelivered !== null && this.state.chartNonPapDeliveredUndelivered !== undefined && this.state.chartNonPapDeliveredUndelivered.length > 0) {
      nonPapDeliveryStatusChart = [];
      var tempNonPapDeliveryStatusChart = [];
      this.state.chartNonPapDeliveredUndelivered.forEach((field) => {
        tempNonPapDeliveryStatusChart.push([
          new Date(field.deliveredOrderYear == 0 ? field.unDeliveredOrderYear : field.deliveredOrderYear, (field.deliveredOrderMonth == 0 ? field.unDeliveredOrderMonth : field.deliveredOrderMonth) - 1, (field.deliveredOrderDay == 0 ? field.unDeliveredOrderDay : field.deliveredOrderDay), 0, 0, 0, 0),
          field.deliveredTotal || 0,
          field.unDeliveredTotal || 0,
        ]);
      });

      tempNonPapDeliveryStatusChart = tempNonPapDeliveryStatusChart.sort(function (a, b) {
        if (a[0] < b[0]) {
          return -1;
        }
        if (b[0] < a[0]) {
          return 1;
        }
        return 0;
      });
      tempNonPapDeliveryStatusChart.forEach((field) => {
        nonPapDeliveryStatusChart.push([
          field[0].toLocaleString('en-el', { day: '2-digit', month: 'short' }),
          field[1] || 0,
          field[2] || 0,
        ]);
      });
      nonPapDeliveryStatusChart.unshift(['date-month', 'Delivered', 'Undelivered']);
    }
    else if (this.props.chartNonPapDataDeliveredUndeliveredLoading == false && nonPapDeliveryStatusChart.length == 1) {
      for (let i = 2; i > 0; i--) {
        let d = new Date((new Date()).setMonth((new Date()).getMonth() - i));
        nonPapDeliveryStatusChart.push([
          new Date(d).toLocaleString('en-el', { day: '2-digit', month: 'short' }),
          0,
          0
        ]);
      }
    }
    let compelianceChart = [
      ['month', 'Compliant', 'Non-compliant'],
    ]
    if (this.state.chart !== null && this.state.chart !== undefined && this.state.chart.length > 0) {
      compelianceChart = [
        ['month', 'Compliant', 'Non-compliant'],
      ]
    let a = 2;

      for (let i = 6; i > 0; i--) {
        let d = new Date((new Date()).setMonth((new Date()).getMonth() - i))
        let month = d.getMonth() + 1;	// Month	[mm]	(1 - 12)
        let date = d.getDate();		// Day		[dd]	(1 - 31)
        let year = d.getFullYear();	// Year		[yyyy]
        let isData = false;
        this.state.chart.forEach((field, index) => {
          if ((month == field.orderMonth && year == field.orderYear) && (this.state.chart[index + 1] == undefined || (field.orderMonth != this.state.chart[index + 1].orderMonth || field.orderMonth == this.state.chart[index + 1].orderMonth))) {
            compelianceChart.push([
              new Date(field.orderYear || 0, (field.orderMonth || 0) - 1, 17, 0, 0, 0, 0).toLocaleString('default', { month: 'short' }),
              field.currentCompliance != 0 ? field.totals : 0,
              field.currentCompliance == 0 && field.totals != 0 ? field.totals : 0,
            ]);
            while (a < compelianceChart.length) {
                compelianceChart[a - 1][1] = compelianceChart[a][1];
                a = a + 2;
            }
            isData = true;
          }
        });
        if (!isData) {
          compelianceChart.push([
            new Date(d).toLocaleString('default', { month: 'short' }),
            0,
            0
          ]);
        }
        }
        if (compelianceChart.length > 10); {
            compelianceChart.splice(2, 1)
            compelianceChart.splice(3, 1)
            compelianceChart.splice(4, 1)
            compelianceChart.splice(5, 1)
            compelianceChart.splice(6, 1);
            compelianceChart.splice(7, 1);
        }
    }
    else if (this.props.chartDataLoading == false && compelianceChart.length == 1) {
      compelianceChart = [
        ['month', 'Compliant', 'Non-compliant'],
      ]
      for (let i = 6; i > 0; i--) {
        let d = new Date((new Date()).setMonth((new Date()).getMonth() - i))
        compelianceChart.push([
          new Date(d).toLocaleString('default', { month: 'short' }),
          0,
          0
        ]);
      }
    }

    let averageMaxAHI30 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxAHI30 : "";
    let averageMaxAHI60 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxAHI60 : "";
    let averageMaxAHI90 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxAHI90 : "";
    let averageMaxLeaks30 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxLeaks30 : "";
    let averageMaxLeaks60 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxLeaks60 : "";
    let averageMaxLeaks90 = this.state.popover.length > 0 ? this.state.popover[0].averageMaxLeaks90 : "";

    let nonPapPatientName = popoverNonPap.length > 0 ? this.get_hidden_string(popoverNonPap[0].patientName) : "";
    let nonPapDoctor = popoverNonPap.length > 0 ? popoverNonPap[0].physician : "";
    let nonPapDOB = popoverNonPap.length > 0 ? new Date(popoverNonPap[0].dob).toLocaleDateString() : "";
    let nonPapNPI = popoverNonPap.length > 0 ? popoverNonPap[0].doctorNPI : "";
    let nonPapPhone = popoverNonPap.length > 0 ? popoverNonPap[0].phone : "";
    let nonPapItem = [];

    this.state.user = this.props.userData
    let selesFilterCount = this.props.salesFilter ? this.props.salesFilter.length : 0
    const salesFilterList = this.props.salesFilter ? this.props.salesFilter.map((value, key) => {
      return (
        value ? <div key={value.name} className="tooltip-block">
          <div className="filter-name"><FontAwesomeIcon icon={["fa", "filter"]} color="gray" className="mr-1" disabled={true} /> {value.name}</div>
          <div className="filter-value"> {value.value}</div>
        </div> : ''
      );
    }) : 'No data';
    const { loading } = this.props;
    const spinner = <span className="loader"></span>;
    const { showModal } = this.state;

    var leftMenuVisibleClass = '';
    if (this.state.isLeftMenuVisible) {
      leftMenuVisibleClass = 'show';
    }

    var leftMenuVisibleClass = '';
    var openIconClass = 'hide-icon-for-left-menu';
    var dashboardRightContentClass = "collapse-dashboard"
    var dashboardLeftMenuVisibleClass = 'hide-leftmenu';
    if (this.state.isOpen) {
      var leftMenuVisibleClass = 'show';
      var openIconClass = 'show-icon';
      var dashboardRightContentClass = 'expand-dashboard';
      var dashboardLeftMenuVisibleClass = 'show-leftmenu';
    }

    return (
      <>
        {
          showModal ? (
            <Modal>
              {this.state.alert}
            </Modal>
          ) : null
        }
        <Helmet>
          <title>Dashboard | Scorecard</title>
        </Helmet>
        <div className="main-content-body dashboard">
          {window.location.pathname == '/dashboard' &&
            <LeftMenu
              dashboardLeftMenuVisibleClass={dashboardLeftMenuVisibleClass}
              isScrrenedPatientPage='true'
              isOpen={this.state.isOpen}
              openIconClass={openIconClass}
              toggleLeftMenuDesktop={this.toggleLeftMenuDesktop}
              leftMenuVisibleClass={leftMenuVisibleClass}
              scrollToBreakDown={this.scrollToBreakDown}
              globalSummaryAccess={this.state.globalSummaryAccess}
              sleepScreenerAccess={this.state.sleepScreenerAccess}
              isPapUser={this.props.isPapUser}
              breakdownClass={this.state.breakdownClass}
              trendsClass={this.state.trendsClass}
              detailsClass={this.state.detailsClass}
              screenerClass=''
            />
          }
          <div className={`container-fluid ${dashboardRightContentClass}`}>
            {this.props.isPapUser == 1 &&
              <div id="breakdown" className="row mx-0">
                <div className="mt-3" style={{ width: "100%" }}>
                  <Accordion className="accordion-title-color" expanded={this.state.panel1 === 'panel1'} onChange={this.handleChange('panel1')}>
                    <AccordionSummary
                      expandIcon={this.state.panel1 === 'panel1' ? <RemoveIcon /> : <AddIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ backgroundColor: "#5867DD" }}
                    >
                      <Typography className=""><FontAwesomeIcon icon={["fa", "chart-pie"]} /><span className="ml-2" >Order and Adherence Breakdowns</span></Typography>
                    </AccordionSummary>
                    <AccordionDetails className="order-and-adherence-breakdowns">
                      <div className="row">
                        <div className="col-lg-6 mt-3">
                          <div className="full-order-breakdowns">
                            <div className="form-inline p-3 breakdown-part" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "box"]} /><span className="ml-2 font-500">Full Order Breakdown</span>
                              </div>
                              <div className="ml-5 breakdown-text" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="ml-2 font-100  pie-block-start">(Previous 60 days based on order</span><br />
                                <span className="ml-2 font-100  pie-block-start">create date)</span>
                              </div>
                            </div>
                            <Divider />
                            {this.state.isLoadingFullOrderBreakdowns == false && orderBreakDownChart.length > 1 ?
                              <div className="font-500 full-order-breakdowns-data " >
                                <div className="dashboard-chart col-lg-12">
                                  <Loader show={this.state.isLoadingFullOrderBreakdowns} message={spinner}>
                                    <Chart
                                      width={'100%'}
                                      height={'300px'}
                                      chartType="PieChart"
                                      // loader={<div style={{ textAlign: "center" }}>Loading Chart</div>}
                                      data={orderBreakDownChart}
                                      rootProps={{ 'data-testid': '1' }}
                                      options={{
                                        enableInteractivity: true,
                                        chartArea: { left: 45, top: 30, botton: 35, width: "100%", height: "80%" },
                                        //  slices: {0: {color: "#FFF"  }, 1:{color: '#00FF08'}, 2:{color: 'blue'}, 3: {color: 'red'}, 4:{color: 'grey'}},
                                        slices: color != undefined ? JSON.parse(JSON.stringify(color).replace(/}}/g, '}').replace(/}]/g, '}}').replace("[{", "{").replace(/,{/g, ',')) : "",
                                      }}
                                      chartEvents={[
                                        {
                                          eventName: "select",
                                          callback: ({ chartWrapper, google, e }) => {

                                            //const chart = chartWrapper.getChart();
                                            var selectedRow = chartWrapper.getChart().getSelection();
                                            if (selectedRow) {
                                              this.loadLegendNameOrdereBreakDowns(filterOrderBreakDownCard[selectedRow[0].row]);
                                            }

                                            var handler = function (e) {
                                              const data = JSON.parse(localStorage.getItem('FullOrderBreakdowns'));
                                              var parts = e.targetID.split("#");
                                              if (data[parseInt(parts[1]) + 1] != undefined) {
                                                const legendNameOrdereBreakDowns = data[parseInt(parts[1]) + 1][0];
                                                // localStorage.setItem('legendNameOrdereBreakDowns', legendNameOrdereBreakDowns);
                                                this.loadLegendNameOrdereBreakDowns(legendNameOrdereBreakDowns);
                                              }
                                            }.bind(this);

                                            google.visualization.events.addListener(
                                              chartWrapper.getChart(),
                                              "click",
                                              handler
                                            );
                                          }
                                        }
                                      ]}
                                    />
                                  </Loader>
                                </div>
                              </div> :
                              <Loader show={this.state.isLoadingFullOrderBreakdowns} message={spinner}>
                                <div className="font-500 compliant-vs-con-compliant-data">
                                  <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.state.isLoadingFullOrderBreakdowns == false && orderBreakDownChart.length == 1 && 'No Data'}</p></div></div>
                              </Loader>
                            }
                          </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                          <div className="adherence-breakdowns">
                            <div className="form-inline p-3 jc-between" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "clipboard-check"]} /><span className="ml-2 font-500">Adherence Breakdowns</span>
                              </div>
                              <div className="adherence-text-previous" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="font-100">(Previous 6 months based on</span><br />
                                <span className="font-100">actual delivery date)</span>
                              </div>
                              <div>
                                <select className="form-control" onChange={(e) => this.handleAdherenceBreakdownsChange(e)}>
                                  <option value="by_status">By Adherence Status</option>
                                  <option value="by_time_period">By Time period</option>
                                  <option value="by_machine_type">By Device</option>
                                  <option value="by_mask">By Mask</option>
                                </select>
                              </div>
                            </div>
                            <Divider />
                            {this.state.isLoadingAdherenceBreakdownsChart == false && this.state.isLoadingAdherenceBreakdownsChartByOption == false && adherenceBreakDownChart.length > 1 ?
                              <div className="font-500 adherence-breakdowns-data">
                                <div className="dashboard-chart col-lg-12">
                                  <Loader show={this.state.isLoadingAdherenceBreakdownsChart} message={spinner}>
                                    <Loader show={this.state.isLoadingAdherenceBreakdownsChartByOption} message={spinner}>

                                      <Chart
                                        width={'100%'}
                                        height={'300px'}
                                        chartType="PieChart"
                                        //loader={<div style={{ textAlign: "center" }}>Loading Chart</div>}
                                        data={adherenceBreakDownChart}
                                        rootProps={{ 'data-testid': '1' }}
                                        options={
                                          {
                                            enableInteractivity: true,
                                            chartArea: { left: 45, top: 30, botton: 35, width: "100%", height: "80%" }
                                          }
                                        }
                                        chartEvents={[
                                          {
                                            eventName: "select",
                                            callback: ({ chartWrapper, google }) => {
                                              const chart = chartWrapper.getChart();

                                              var selectedRow = chartWrapper.getChart().getSelection();
                                              if (selectedRow) {
                                                this.loadLegendNameAdherenceBreakDowns(filterAdherenceBreakDownChart[selectedRow[0].row]);
                                              }

                                              var handler = function (e) {
                                                const data = JSON.parse(localStorage.getItem('AdherenceBreakDowns'));
                                                var parts = e.targetID.split("#");
                                                if (data[parseInt(parts[1]) + 1] != undefined) {
                                                  const legendNameAdherenceBreakDowns = data[parseInt(parts[1]) + 1][0];
                                                  // localStorage.setItem('legendNameAdherenceBreakDowns', legendNameAdherenceBreakDowns);
                                                  this.loadLegendNameAdherenceBreakDowns(legendNameAdherenceBreakDowns)
                                                }
                                              }.bind(this);
                                              google.visualization.events.addListener(
                                                chartWrapper.getChart(),
                                                "click",
                                                handler
                                              );
                                            }
                                          }
                                        ]}
                                      />
                                    </Loader>
                                  </Loader>
                                </div>
                              </div> :
                              <Loader show={this.state.isLoadingAdherenceBreakdownsChart} message={spinner}>
                                <Loader show={this.state.isLoadingAdherenceBreakdownsChartByOption} message={spinner}>
                                  <div className="font-500 compliant-vs-con-compliant-data">
                                    <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.state.isLoadingAdherenceBreakdownsChart == false && this.state.isLoadingAdherenceBreakdownsChartByOption == false && adherenceBreakDownChart.length == 1 && 'No Data'}</p></div></div>
                                </Loader>
                              </Loader>
                            }
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            }
            {this.props.isPapUser == 1 &&

              <div id="trends" className="row mx-0">
                <div className="mt-3" style={{ width: "100%" }}>
                  <Accordion className="accordion-title-color" expanded={this.state.panel2 === 'panel2'} onChange={this.handleChange('panel2')}>
                    <AccordionSummary
                      expandIcon={this.state.panel2 === 'panel2' ? <RemoveIcon /> : <AddIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      style={{ backgroundColor: "#34BFA3" }}
                    >
                      <Typography className=""><FontAwesomeIcon icon={["fa", "chart-line"]} /><span className="ml-2" >Order and Adherence Trends</span></Typography>
                    </AccordionSummary>
                    <AccordionDetails className="order-and-adherence-trends">
                      <div className="row">
                        <div className="col-lg-6 mt-3">
                          <div className="delivered-vs-undelivered">
                            <div className="form-inline p-3" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "truck"]} /><span className="ml-2 font-500">Delivered vs. Undelivered</span>
                              </div>
                              <div className="ml-5" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="ml-2 font-100  pie-block-start">(Previous 60 days based on order create</span><br />
                                <span className="ml-2 font-100  pie-block-start">date)</span>
                              </div>
                            </div>
                            <Divider />
                            {this.props.chartDataLoading == false && deliveryStatusChart.length > 1 ?
                              <div className="font-500 delivered-vs-undelivered-data">
                                <div className="dashboard-chart col-lg-12">
                                  <Loader show={this.state.isLoadingDeliveredUndelivered} message={spinner}>
                                    <Chart
                                      width={'100%'}
                                      height={'300px'}
                                      chartType="LineChart"
                                      //  loader={<div>Loading Chart</div>}
                                      data={deliveryStatusChart}
                                      options={{
                                        pointsVisible: true,
                                        legend: 'none',
                                        chartArea: { left: 30, top: 15, right: 15, bottom: 35, width: "100%", height: "100%" },
                                        series: {
                                          0: { curveType: 'function' },
                                          1: { curveType: 'function' },
                                        },
                                        vAxis: { viewWindow: { min: 0 } }
                                      }}
                                      rootProps={{ 'data-testid': '1' }}
                                    />
                                  </Loader>
                                </div>
                              </div> :
                              <Loader show={this.state.isLoadingDeliveredUndelivered} message={spinner}>
                                <div className="font-500 compliant-vs-con-compliant-data">
                                  <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.props.chartDataLoading == false && deliveryStatusChart.length == 1 && 'No Data'}</p></div></div>
                              </Loader>
                            }
                          </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                          <div className="compliant-vs-con-compliant">
                            <div className="form-inline p-3" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "clipboard-check"]} /><span className="ml-2 font-500">Compliant vs. Non-Compliant</span>
                              </div>
                              <div className="ml-5 compliant-right-text" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="font-100">(Previous 6 months based on actual delivery</span><br />
                                <span className="font-100">date)</span>
                              </div>
                            </div>
                            <Divider />
                            {this.props.chartDataLoading == false && compelianceChart.length > 1 ?
                              <div className="font-500 compliant-vs-con-compliant-data">
                                <div className="dashboard-chart  col-lg-12">
                                  <Loader show={this.state.isLoadingComplianceNonCompliance} message={spinner}>
                                    <Chart
                                      width={'100%'}
                                      height={'300px'}
                                      chartType="LineChart"
                                      // loader={<div>Loading Chart</div>}
                                      data={compelianceChart}
                                      options={{
                                        pointsVisible: true,
                                        legend: 'none',
                                        chartArea: { left: 30, top: 15, right: 15, bottom: 35, width: "100%", height: "100%" },
                                        series: {
                                          0: { curveType: 'function' },
                                          1: { curveType: 'function' },
                                        },
                                        vAxis: { viewWindow: { min: 0 } }
                                      }}
                                      rootProps={{ 'data-testid': '1' }}
                                    />
                                  </Loader>
                                </div>
                              </div> :
                              <Loader show={this.state.isLoadingComplianceNonCompliance} message={spinner}>
                                <div className="font-500 compliant-vs-con-compliant-data">
                                  <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.props.chartDataLoading == false && compelianceChart.length == 1 && 'No Data'}</p></div></div>
                              </Loader>
                            }
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            }

            {this.props.isPapUser == 0 &&
              <div id="breakdown" className="row mx-0">
                <div className="mt-3" style={{ width: "100%" }}>
                  <Accordion className="accordion-title-color" expanded={this.state.panel2 === 'panel2'} onChange={this.handleChange('panel2')}>
                    <AccordionSummary
                      expandIcon={this.state.panel2 === 'panel2' ? <RemoveIcon /> : <AddIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      style={{ backgroundColor: "#5867DD" }}
                    >
                      <Typography className=""><FontAwesomeIcon icon={["fa", "chart-pie"]} /><span className="ml-2" >Order Breakdown and Trend</span></Typography>
                    </AccordionSummary>
                    <AccordionDetails className="order-and-adherence-trends">
                      <div className="row">
                        <div className="col-lg-6 mt-3">
                          <div className="full-order-breakdowns">
                            <div className="form-inline p-3 breakdown-part" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "box"]} /><span className="ml-2 font-500">Full Order Breakdown</span>
                              </div>
                              <div className="ml-5 breakdown-text" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="ml-2 font-100 pie-block-start">(Previous 60 days based on order</span><br />
                                <span className="ml-2 font-100 pie-block-start">create date)</span>
                              </div>
                            </div>
                            <Divider />
                            {this.state.isLoadingNonPapFullOrderBreakDowns == false && nonPapOrderBreakDownChart.length > 1 ?
                              <div className="font-500 full-order-breakdowns-data " >
                                <div className="dashboard-chart col-lg-12">
                                  <Loader show={this.state.isLoadingNonPapFullOrderBreakDowns} message={spinner}>
                                    <Chart
                                      width={'100%'}
                                      height={'300px'}
                                      chartType="PieChart"
                                      // loader={<div style={{ textAlign: "center" }}>Loading Chart</div>}
                                      data={nonPapOrderBreakDownChart}
                                      rootProps={{ 'data-testid': '1' }}
                                      options={
                                        {
                                          enableInteractivity: true,
                                          chartArea: { left: 45, top: 15, botton: 35, width: "100%", height: "90%" }
                                        }
                                      }
                                      chartEvents={[
                                        {
                                          eventName: "select",
                                          callback: ({ chartWrapper, google }) => {
                                            const chart = chartWrapper.getChart();

                                            // var selectedRow = chartWrapper.getChart().getSelection();
                                            // if (selectedRow) {
                                            //   console.log('selectedRow', selectedRow);
                                            //   // console.log('hello', filterOrderBreakDownCard, filterOrderBreakDownCard[selectedRow[0].row]);
                                            //   // this.loadLegendNameNonPapOrdereBreakDowns(filterOrderBreakDownCard[selectedRow[0].row]);
                                            // }

                                            var handler = function (e) {
                                              const data = JSON.parse(localStorage.getItem('nonPapFullOrderBreakDowns'));
                                              var parts = e.targetID.split("#");
                                              if (data[parseInt(parts[1]) + 1] != undefined) {
                                                const legendNameNonPapOrdereBreakDowns = data[parseInt(parts[1]) + 1][0];
                                                // localStorage.setItem('legendNameNonPapOrdereBreakDowns', legendNameNonPapOrdereBreakDowns);
                                                this.loadLegendNameNonPapOrdereBreakDowns(legendNameNonPapOrdereBreakDowns)
                                              }
                                            }.bind(this);
                                            google.visualization.events.addListener(
                                              chartWrapper.getChart(),
                                              "click",
                                              handler
                                            );
                                          }
                                        }
                                      ]}
                                    />
                                  </Loader>
                                </div>
                              </div> :
                              <Loader show={this.state.isLoadingNonPapFullOrderBreakDowns} message={spinner}>
                                <div className="font-500 compliant-vs-con-compliant-data">
                                  <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.state.isLoadingNonPapFullOrderBreakDowns == false && nonPapOrderBreakDownChart.length == 1 && 'No Data'}</p></div></div>
                              </Loader>
                            }
                          </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                          <div className="compliant-vs-con-compliant">
                            <div className="form-inline p-3" style={{ height: '65px' }}>
                              <div>
                                <FontAwesomeIcon icon={["fa", "clipboard-check"]} /><span className="ml-2 font-500">Delivered vs. Undelivered</span>
                              </div>
                              <div className="ml-5" style={{ fontSize: '11px', color: 'gray' }}>
                                <span className="font-100  pie-block-start">(Previous 60 days based on order create</span><br />
                                <span className="font-100  pie-block-start">date)</span>
                              </div>
                            </div>
                            <Divider />
                            {this.props.chartNonPapDataDeliveredUndeliveredLoading == false && nonPapDeliveryStatusChart.length > 1 ?
                              <div className="font-500 compliant-vs-con-compliant-data">
                                <div className="dashboard-chart col-lg-12">
                                  <Loader show={this.state.isLoadingNonPapDeliveredUndelivered} message={spinner}>
                                    <Chart
                                      width={'100%'}
                                      height={'300px'}
                                      chartType="LineChart"
                                      // loader={<div style={{ textAlign: "center" }}>Loading Chart</div>}
                                      data={nonPapDeliveryStatusChart}
                                      options={{
                                        pointsVisible: true,
                                        legend: 'none',
                                        chartArea: { left: 30, top: 15, right: 15, bottom: 45, width: "100%", height: "100%" },
                                        series: {
                                          0: { curveType: 'function' },
                                          1: { curveType: 'function' },
                                        },
                                        vAxis: { viewWindow: { min: 0 } }
                                      }}
                                      rootProps={{ 'data-testid': '1' }}
                                    />
                                  </Loader>
                                </div>
                              </div> : <Loader show={this.state.isLoadingNonPapDeliveredUndelivered} message={spinner}>
                                <div className="font-500 compliant-vs-con-compliant-data">
                                  <div className="dashboard-chart"><p style={{ textAlign: "center", fontSize: 12 }}>{this.props.chartNonPapDataDeliveredUndeliveredLoading == false && nonPapDeliveryStatusChart.length == 1 && 'No Data'}</p></div></div>
                              </Loader>
                            }
                          </div>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
            }

            <div id="details" className="row mx-0">
              <div className="mt-3" style={{ width: "100%" }}>
                <Accordion className="accordion-title-color" ref={this.state.salesOrderDiv} expanded={this.state.panel3 === 'panel3'} onChange={this.handleChange('panel3')}>
                  <AccordionSummary
                    expandIcon={this.state.panel3 === 'panel3' ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                    style={{ backgroundColor: "#FFB822" }}
                  >
                    <Typography className=""><FontAwesomeIcon icon={["fa", "clipboard-list"]} /><span className="ml-2" >{this.props.isPapUser == 0 ? 'Order Details' : 'Order and Adherence Details'}</span></Typography>
                  </AccordionSummary>
                  <AccordionDetails className="order-and-adherence-details">
                    <div className="row">
                      <div className="col-lg-12 mt-3">
                        <div className="order-and-adherence-detail">
                          <div className="form-inline p-3 jc-between" style={{ height: '65px' }}>
                            <div>
                              <Tooltip enterTouchDelay={1} title="Previous 12 months based on order date" style={{display: 'inline'}}>
                                <div>
                                  <FontAwesomeIcon icon={["fa", "info-circle"]} />
                                </div>
                              </Tooltip>
                              <span className="ml-2 font-500">Details</span>
                            </div>
                            <div className="tooltip-btn-dashboard" style={{ fontSize: '11px', color: 'gray' }}>


                              {/* <ClickAwayListener onClickAway={this.handleTooltipClose}> */}
                              <div className="d-inline sales-list-filter">
                                <Tooltip
                                  PopperProps={{
                                    disablePortal: true,
                                  }}
                                  arrow
                                  placement="left"
                                  onClose={this.handleTooltipClose}
                                  open={this.state.showFilter}
                                  disableFocusListener
                                  disableHoverListener
                                  disableTouchListener
                                  title={
                                    <React.Fragment>
                                      <div>
                                        <div>{salesFilterList}</div>
                                      </div>
                                    </React.Fragment>
                                  }
                                >
                                  <button onClick={this.handleToggleTooltip} className={selesFilterCount > 0 ? `btn btn-light btn-primary apply-filter apply-filter-tooltip` : `btn btn-light `} disabled={selesFilterCount <= 0} >
                                    <FontAwesomeIcon icon={["fa", "filter"]} color={selesFilterCount > 0 ? 'white' : 'gray'} className="mr-1" disabled={true} />
                                    {selesFilterCount > 0 ? selesFilterCount : 'No'} filter(s) applied
                                  </button>
                                </Tooltip>
                              </div>
                              {/* </ClickAwayListener> */}
                              {
                                selesFilterCount > 0 ?
                                  <button onClick={this.handleResetFilter} className={`btn btn-light btn-elevate ml-1`} >
                                    <FontAwesomeIcon icon={["fa", "times"]} color="gray" />
                                  </button> : ''
                              }

                            </div>
                          </div>
                          <Divider />
                          <div className="font-500 order-and-adherence-details-data" style={{ height: 480 }}>
                            {this.props.isPapUser == 1 &&
                              <div className="row p-3">
                                <div className="col-lg-12">
                                  {/* <input type="text" placeholder="Search..." className="form-control mb-3" onChange={this.changeSearch} style={{ width: '200px', backgroundColor: '#F4F5F8' }} /> */}
                                  <div style={{ maxWidth: '100%' }} className="tabledata">
                                    <MaterialTable
                                      icons={tableIcons}
                                      // onSearchChange={this.changeSearch}
                                      // onChangePage={this.changePage}
                                      // onOrderChange={this.changeOrderByPap}
                                      // onChangeRowsPerPage={this.changeRowsPerPage}
                                      className="client-listing"
                                      columns={[
                                        {
                                          title: 'Patient Name',
                                          field: 'patientName',
                                          render: (rowData) => {
                                            let patientName = this.get_hidden_string(rowData.patientName)

                                            let visiblityDiv = { display: 'block' };
                                            if (this.state.isLoadingNonPapPopover) {
                                              visiblityDiv = { visibility: 'hidden' };
                                            }

                                            let loaderValue = false;
                                            if (this.state.isLoadingNonPapPopover || this.state.isLoadingDocument) {
                                              loaderValue = true;
                                            }

                                            if (this.state.popupDetailName) {
                                              this.setState({});
                                            }

                                            return (
                                              <div>

                                                { rowData.patientName != "" ? <div>
                                                  <Link id={`Popover${rowData.ptKey}${rowData.rowId}`} >{patientName}</Link>
                                                  <Popover placement="right" isOpen={this.state.popoverOpen && this.state.selectedPtKey == rowData.rowId} target={`Popover${rowData.ptKey}${rowData.rowId}`} toggle={(e) => this.toggle(rowData.ptKey, rowData)}>
                                                    <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#FFF" }}>
                                                      <FontAwesomeIcon icon={["fa", "user"]} />  Patient Info <FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} onClick={this.outsideClick} icon={["fa", "times"]} /> Patient Note </PopoverHeader>
                                                    <Loader show={loaderValue} message={spinner}>
                                                      <PopoverBody style={visiblityDiv}>
                                                        <div className="dashboard-patientinfo-block">
                                                          <div className="row">
                                                            <span className="col-6 mb-2" ><b>Name: </b>{patientName}</span>
                                                            <span className="col-6 mb-2"><b>Referral: </b>{rowData.referral}</span>
                                                          </div>
                                                          <div className="row">
                                                            <span className="col-6 mb-2"><b>DOB: </b>{(new Date(rowData.dob)).toLocaleDateString()}</span>
                                                            <span className="col-6 mb-2"><b>Machine Type: </b>{rowData.papMachineType}</span>
                                                          </div>
                                                          <div className="row">
                                                            <span className="col-6 mb-2"><b>Phone#: </b>{rowData.pt_PhoneNumber} </span>
                                                            <span className="col-6 mb-2"><b>Mask Type: </b>{rowData.maskType}</span>
                                                          </div>
                                                          {rowData.totalAttempts && rowData.totalAttempts != null ?
                                                            <div className="row">
                                                              <span className="col-6 mb-2"><b># of Attempts: </b>{rowData.totalAttempts} </span>
                                                            </div> : ''
                                                          }
                                                          <div className="row" >
                                                            <span className="col-6 mb-2"><b>Primary Ins: </b>{rowData.primary_Insurance}</span>
                                                            <span className="col-6 mb-2">{rowData.airviewFlag != null || rowData.encoreFlag != null ? <b>Compliance and Therapy Summary: </b> : ''} <br /><span style={{ color: "blue" }}>
                                                              {
                                                                rowData.airviewFlag && rowData.airviewFlag != null ? <div>
                                                                  <Link onClick={(e) => this.handleResmedSummaryDocument({ airviewFlag: rowData.airviewFlag, days: 30 })}>30 Days </Link>
                                                                  <Link onClick={(e) => this.handleResmedSummaryDocument({ airviewFlag: rowData.airviewFlag, days: 60 })}>60 Days </Link>
                                                                  <Link onClick={(e) => this.handleResmedSummaryDocument({ airviewFlag: rowData.airviewFlag, days: 90 })}>90 Days </Link>
                                                                </div> : ''

                                                              }
                                                              {
                                                                rowData.encoreFlag && rowData.encoreFlag != null ? <div>
                                                                  <Link onClick={(e) => this.handleEncoreSummaryDocument({ encoreFlag: rowData.encoreFlag, days: 30 })}>30 Days </Link>
                                                                  <Link onClick={(e) => this.handleEncoreSummaryDocument({ encoreFlag: rowData.encoreFlag, days: 60 })}>60 Days </Link>
                                                                  <Link onClick={(e) => this.handleEncoreSummaryDocument({ encoreFlag: rowData.encoreFlag, days: 90 })}>90 Days </Link>
                                                                </div> : ''

                                                              }

                                                            </span></span>
                                                          </div>
                                                          <div className="row">
                                                            <span className="col-6 mb-2"><b>Doctor: </b>{rowData.doctorName}</span>
                                                            < span className="col-6 mb-2">{rowData.airviewFlag != null || rowData.encoreFlag != null ? <b>View Patient: </b> : ''}

                                                              {
                                                                rowData.airviewFlag && rowData.airviewFlag != null ? <Link
                                                                  component="button"
                                                                  variant="body2"
                                                                  style={{
                                                                    backgroundColor: "#36A3F7", border: "none", padding: 5,
                                                                    color: "#FFF"
                                                                  }}
                                                                  onClick={() => window.open("https://airview.resmed.com/patients/" + rowData.airviewFlag + "/charts", "_blank")}
                                                                >
                                                                  Air View
                                                                </Link> : ''
                                                              }

                                                              {
                                                                rowData.encoreFlag && rowData.encoreFlag != null ? <Link
                                                                  component="button"
                                                                  variant="body2"
                                                                  style={{
                                                                    backgroundColor: "#36A3F7", border: "none", padding: 5,
                                                                    color: "#FFF"
                                                                  }}
                                                                  onClick={() => window.open("https://www.careorchestrator.com/#/patient/" + rowData.encoreFlag + "/summary?activeReportFamily=1&timeframe=0&daysSelection=30&days=30", "_blank")}
                                                                >
                                                                  Care Orchestrator
                                                                </Link> : ''
                                                              }

                                                            </span>
                                                          </div>
                                                        </div>
                                                      </PopoverBody>
                                                      <PopoverHeader style={{ backgroundColor: "#34bfa3", color: "#FFF" }}><FontAwesomeIcon icon={["fa", "clipboard-check"]} /> Adherence Info, AHI, Leaks</PopoverHeader>
                                                      <PopoverBody className="dashboard-patientinfo-block" style={visiblityDiv}>
                                                        <div className="row">
                                                          <span className="col-3">Average AHI</span>
                                                          <span className="col-3">30-day<br /><b>{averageMaxAHI30}m/l</b></span>
                                                          <span className="col-3">60-day<br /><b>{averageMaxAHI60}m/l</b></span>
                                                          <span className="col-3">90-day<br /><b>{averageMaxAHI90}m/l</b></span>
                                                        </div>
                                                        <div className="row">
                                                          <span className="col-3">Average Leaks</span>
                                                          <span className="col-3">30-day<br /><b>{averageMaxLeaks30}</b></span>
                                                          <span className="col-3">60-day<br /><b>{averageMaxLeaks60}</b></span>
                                                          <span className="col-3">90-day<br /><b>{averageMaxLeaks90}</b></span>
                                                        </div>
                                                        <div className="row">
                                                          <span className="col-3">Adherence</span>
                                                          <span className="col-3">30-day<br /><b>{rowData.compliant30}</b></span>
                                                          <span className="col-3">60-day<br /><b>{rowData.compliant60}</b></span>
                                                          <span className="col-3">90-day<br /><b>{rowData.compliant90}</b></span>
                                                        </div>
                                                        <div className="row">
                                                          <span className="col-3"></span>

                                                          <span className="col-3">Days Since Setup<br /><b>{rowData.daysSinceSetUp}</b></span>
                                                          <span className="col-3">Adherence<br />
                                                            {rowData.compliantPctSinceSetup > 0 ? <div className="progress" style={{ height: '16px' }}>< div className="progress-bar" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style={{ width: `${rowData.compliantPctSinceSetup}%`, color: "black" }}> {rowData.compliantPctSinceSetup}% </div> </div> : <strong><label>0%</label></strong>}
                                                          </span>
                                                          <span className="col-3">Best 30<br /><b>{rowData.best30StartDT == null || rowData.best30StartDT == "" ? "" : (new Date(rowData.best30StartDT)).toLocaleDateString()}-{rowData.best30EndDT == null || rowData.best30EndDT == "" ? "" : (new Date(rowData.best30EndDT)).toLocaleDateString()}</b></span>
                                                        </div>
                                                      </PopoverBody>
                                                    </Loader>
                                                  </Popover>
                                                </div> : "-"}
                                              </div>
                                            )
                                          }
                                        },
                                        {
                                          title: 'DOB',
                                          field: 'dob',
                                          type: "date",
                                          width: "150px",
                                          render: rowData => {
                                            return rowData.dob ? rowData.dob : '-';
                                          }
                                        },
                                        {
                                          title: 'Phone Number',
                                          field: 'pt_PhoneNumber',
                                          hidden: this.state.pt_PhoneNumberIsHidden,
                                          render: rowData => {
                                            return rowData.pt_PhoneNumber ? rowData.pt_PhoneNumber : '-';
                                          },
                                        },
                                        {
                                          title: 'Mobile Number',
                                          field: 'pt_MobileNumber',
                                          hidden: this.state.pt_MobileNumberIsHidden,
                                          render: rowData => {
                                            return rowData.pt_MobileNumber ? rowData.pt_MobileNumber : '-';
                                          },
                                        },
                                        {
                                          title: 'Current Compliance',
                                          field: 'risk',
                                          hidden: this.state.compliancePctIsHidden,
                                          render: rowData => {
                                            return rowData.risk ? rowData.risk : '-';
                                          },
                                        },
                                        {
                                          title: 'Days Since Set Up',
                                          field: 'daysSinceSetUp',
                                          hidden: this.state.daysSinceSetupIsHidden,
                                          render: rowData => {
                                            return rowData.daysSinceSetUp ? rowData.daysSinceSetUp : '-';
                                          },
                                        },
                                        {
                                          title: 'Compliant Days Since Set Up',
                                          field: 'compliantDaysSinceSetup',
                                          hidden: this.state.compliantDaysSinceSetupIsHidden,
                                          render: rowData => {
                                            return rowData.compliantDaysSinceSetup ? rowData.compliantDaysSinceSetup : '-';
                                          },
                                        },
                                        {
                                          title: 'Adherence %',
                                          field: 'compliantPctSinceSetup',
                                          hidden: this.state.isClickedIsHidden,
                                          render: rowData => {
                                            return rowData.compliantPctSinceSetup ? rowData.compliantPctSinceSetup + '%' : '-';
                                          }
                                        },
                                        {
                                          title: 'Created At',
                                          field: 'soCreateDT',
                                          type: "date",
                                          hidden: this.state.soCreateDtIsHidden,
                                          render: rowData => {
                                            return rowData.soCreateDT && moment(rowData.soCreateDT).format('MM/DD/YYYY').toString() != "01/01/0001" ? moment(rowData.soCreateDT).format('MM/DD/YYYY') : '-';
                                          }
                                        },
                                        {
                                          title: 'Delivered At',
                                          field: 'deliveredDt',
                                          type: "date",
                                          hidden: this.state.deliveredDtIsHidden,
                                          render: rowData => {
                                            return rowData.deliveredDt && moment(rowData.deliveredDt).format('MM/DD/YYYY').toString() != "01/01/0001" ? moment(rowData.deliveredDt).format('MM/DD/YYYY') : '-';
                                          }
                                        },
                                        {
                                          title: 'Equipment',
                                          field: 'equipment',
                                          hidden: this.state.equipmentIsHidden,
                                          render: rowData => {
                                            return rowData.equipment ? rowData.equipment : '-';
                                          },
                                        },
                                        {
                                          title: 'PAP Machine Type',
                                          field: 'papMachineType',
                                          hidden: this.state.parMachineTypeIsHidden,
                                          render: rowData => {
                                            return rowData.papMachineType ? rowData.papMachineType : '-';
                                          },
                                        },
                                        {
                                          title: 'Mask Type',
                                          field: 'maskType',
                                          hidden: this.state.maskTypeIsHidden,
                                          render: rowData => {
                                            return rowData.maskType ? rowData.maskType : '-';
                                          },
                                        },
                                        {
                                          title: 'Order Status',
                                          field: 'orderStatus',
                                          hidden: this.state.orderStatusIsHidden,
                                          ...this.state.currentSortOrderPap,
                                          cellStyle: {
                                            verticalAlign: "middle"
                                          },
                                          render: rowData => {
                                            return (
                                              <div > <p style={{ color: "#FFF", width: 180, backgroundColor: colors[rowData.orderStatus], borderRadius: 10, textAlign: "center" }}>{rowData.orderStatus ? rowData.orderStatus : '-'}</p> </div>
                                            )
                                          },
                                        },
                                        {
                                          title: 'Order Note',
                                          field: 'orderNote',
                                          hidden: this.state.orderNoteIsHidden,
                                          render: rowData => {
                                            return rowData.orderNote ? rowData.orderNote : '-';
                                          },
                                        },
                                        {
                                          title: 'Doctor Name',
                                          field: 'doctorName',
                                          render: rowData => {
                                            return rowData.doctorName ? rowData.doctorName : '-';
                                          },
                                        },
                                      ]}
                                      data={this.state.user ? this.state.user : []}
                                      totalCount={this.state.totalRecords ? this.state.totalRecords : 0}
                                      isLoading={this.state.isLoading}
                                      onOrderChange={this.changeOrderByPap}
                                      localization={{
                                        body: {
                                          emptyDataSourceMessage: this.state.isLoadingNonPap == true
                                            ? "Loading..." : "No sales order to display"
                                        }
                                      }}
                                      options={{
                                        maxBodyHeight: 350,
                                        minBodyHeight: this.state.totalRecords == 0 ? 0 : 350,
                                        overflowY: "auto",
                                        padding: "dense",
                                        searchFieldAlignment: 'left',
                                        showTitle: false,
                                        toolbar: true,
                                        actionsColumnIndex: -1,
                                        search: true,
                                        draggable: false,
                                        pageSize: 100,
                                        cellStyle: {
                                          padding: "10px",
                                          color: '#575962',
                                          fontSize: "13px",
                                        },
                                        headerStyle: {
                                          backgroundColor: '#f4f3f8',
                                          color: '#575962',
                                          padding: "15px 10px",
                                          fontSize: "13px",
                                        },
                                        paging: this.state.totalRecords == 0 ? false : true,
                                        pageSizeOptions: [5, 10, 20, 50, 100]
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            }

                            {this.props.isPapUser == 0 &&
                              <div className="row p-3">
                                <div className="col-lg-12">
                                  <div style={{ maxWidth: '100%' }} className="tabledata">
                                    <MaterialTable
                                      icons={tableIcons}
                                      className="client-listing"
                                      columns={[
                                        {
                                          title: 'Patient Name',
                                          field: 'patientName',
                                          render: (rowData) => {
                                            let patientName = this.get_hidden_string(rowData.patientName)

                                            let visiblityDiv = { display: 'block' };
                                            if (this.state.isLoadingNonPapPopover) {
                                              visiblityDiv = { visibility: 'hidden' };
                                            }

                                            return (
                                              <div>
                                                { rowData.patientName != "" ?
                                                  <div>
                                                    <Link id={`Popover${rowData.patientName.replace(/[^a-zA-Z]/g, "")}`} >{patientName}</Link>
                                                    <Popover style={{ width: 'auto' }} placement="right" isOpen={this.state.popoverOpen && this.state.selectedPatientName.replace(/[^a-zA-Z]/g, "") == rowData.patientName.replace(/[^a-zA-Z]/g, "")} target={`Popover${rowData.patientName.replace(/[^a-zA-Z]/g, "")}`} toggle={(e) => this.toggleNonPap(rowData.patientName)}>
                                                      <Loader show={this.state.isLoadingNonPapPopover} message={spinner}>
                                                        <PopoverBody style={visiblityDiv}>
                                                          <div class="tab-link">
                                                          <span><FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} onClick={this.outsideClickNonPap} icon={["fa", "times"]} /></span>
                                                            <div class="nav-link">
                                                              <ul>
                                                                <li onClick={(e) => this.patientDetailHeaderClick(true)}><button className={`btn btn-primary ${this.state.showPatientDetails ? "active" : ""}`} id="tab1">Patient Info</button></li>
                                                                <li onClick={(e) => this.patientDetailHeaderClick(false)} className={`${patientNoteList.length > 0 ? "" : "d-none"}`}><button class={`btn btn-primary ${this.state.showPatientNotes ? "active" : ""}`} id="tab2">Patient Notes</button></li>
                                                              </ul>
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <div className="row">
                                                              <span className="col-6 mb-2"><b>Name:</b> {nonPapPatientName ? nonPapPatientName : '-'}
                                                              </span>
                                                              <span className="col-6 mb-2"><b>Doctor:</b> {nonPapDoctor ? nonPapDoctor : '-'}
                                                              </span>
                                                            </div>
                                                            <div className="row">
                                                              <span className="col-6 mb-2"><b>DOB:</b> {nonPapDOB ? nonPapDOB : '-'}
                                                              </span>
                                                              <span className="col-6 mb-2"><b>NPI:</b> {nonPapNPI ? nonPapNPI : '-'}
                                                              </span>
                                                            </div>
                                                            <div className="row">
                                                              <span className="col-6 mb-2"><b>Phone  #:</b> {nonPapPhone ? nonPapPhone : '-'}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </PopoverBody>
                                                        <PopoverBody style={visiblityDiv} className={`${this.state.showPatientNotes ? "d-none" : ""}`}>
                                                          {popoverNonPap != null && popoverNonPap != undefined && popoverNonPap.length > 0 &&
                                                            <div id="non-pap-listing-div" class="tab-content tab-content1">
                                                              <Tabs transition={false} id="non-pap-listing-tab">
                                                                {popoverNonPap.map((data, i) => {
                                                                  if (popoverNonPap[i - 1] == undefined || data.orderNumber != popoverNonPap[i - 1].orderNumber) {
                                                                    nonPapItem = [];
                                                                  }
                                                                  if (popoverNonPap[i + 1] != undefined && data.orderNumber == popoverNonPap[i + 1].orderNumber) {
                                                                    nonPapItem.push(data.prodDesc + ' - Qty ' + data.orderedQty)
                                                                  }
                                                                  else {
                                                                    nonPapItem.push(data.prodDesc + ' - Qty ' + data.orderedQty)
                                                                    if(data.orderNumber !== 1 && data.orderNumber !== 2){
                                                                    return (
                                                                      <Tab eventKey={`${data.orderNumber}`} title={`SO# ${data.orderNumber}`} tabClassName={data.orderStatus == null ? "no-shipped" : "shipped"}>
                                                                        <div className="row">
                                                                          <div className="col-6">
                                                                            <div className="mb-2"><b>SO Number:</b> {data.orderNumber ? data.orderNumber : '-'}</div>
                                                                            <div className="mb-2"><b>Classification:</b> {data.classification ? data.classification : '-'}</div>
                                                                            <div className="mb-2"><b>DOS:</b> {data.statusDate ? data.statusDate : '-'}</div>
                                                                            <div className="mb-2"><b>Create Date:</b> {data.dateEntered ? data.dateEntered : '-'}</div>
                                                                            <div className="mb-2"><b>WIP State:</b> {data.orderStatus ? data.orderStatus : '-'}</div>
                                                                            <div className="mb-2"><b>Status:</b> {data.orderStatus ? data.orderStatus : '-'}</div>
                                                                            {data.orderStatus == "Shipped" && <div className="mb-2"><b>Tracking No:</b>

                                                                              <Link onClick={(e) => this.showTrackingNumber({ trackingNbr: data.trackingNbrUrl })}> {data.trackingNbr} </Link>

                                                                            </div>}
                                                                            <div className="mb-2"><b>Primary Ins:</b> {data.payer ? data.payer : '-'}</div>
                                                                            <div className="mb-2"><b>Refferal:</b> {data.referralName ? data.referralName : '-'}</div>
                                                                          </div>
                                                                          <div className="col-6">
                                                                            <div>
                                                                              <h6>Items</h6>
                                                                              <div>
                                                                                <ul>
                                                                                  {nonPapItem.map((data) => {
                                                                                    return (
                                                                                      <li>
                                                                                        {data}
                                                                                      </li>
                                                                                    )
                                                                                  })
                                                                                  }
                                                                                </ul>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </Tab>
                                                                    )
                                                                  }
                                                                  if((data.orderNumber != null && data.orderNumber === 2) || (data.orderNumber != null && data.orderNumber === 1)){
                                                                    let title = data.orderNumber == 1 ? 'Outsourced' : 'Cancelled';
                                                                    let cancelOutsourceData = data.orderNumber == 1 ? liOutsourcedOrderResponse : liCancelledOrderResponse;

                                                                    if (cancelOutsourceData.length == 0) {
                                                                        return false;
                                                                    }
                                                                    return (
                                                                        <Tab eventKey={`${data.orderNumber}`} title={`${title}`}>
                                                                            <table className="follow-up-table" style={{ border: "1px solid #000", color: "#000", width: '100%' }}>
                                                                              <tbody>
                                                                              <tr style={{backgroundColor: '#c1c1c1aa'}}>
                                                                                <td style={{ width: "106px", textAlign: 'center', fontWeight:'bold' }}>Create Date</td>
                                                                                <td style={{ width: "200px", fontWeight:'bold' }}>Details</td>
                                                                              </tr>
                                                                              {
                                                                                cancelOutsourceData.map((data, i) => 
                                                                                  <tr key={i}> 
                                                                                    <td style={{ width: "120px", textAlign: 'center', fontWeight:'bold' }}>
                                                                                      { 
                                                                                            (isInternalRole) ? <> <a onClick={(e) => this.descPopverToggle(data)} href="javascript:void(0)" id={`descPopover${data.noteID}`} style={{ color: "#052fff", textDecorationLine: "underline" }}>{data.createDt}</a>
                                                                                                {/*<a href={`https://brightree.net/F1/01954/MPCS/Patient/frmPatientNote.aspx?PatientKey=${data.ptKey}&Edit=1&PatientNoteKey=${data.noteID}&PatientNoteTypeKey=2`} target="_blank" style={{ color: "#052fff", textDecorationLine: "underline" }}>
                                                                                                        
                                                                                                </a>*/}
                                                                                                <Popover placement="bottom" isOpen={this.state.descPopoverOpen} target={`descPopover${data.noteID}`} toggle={this.descPopverToggle}>
                                                                                                    <PopoverHeader><b>Order Description</b><FontAwesomeIcon style={{ float: "right", cursor: "pointer" }} onClick={this.descPopverToggle} icon={["fa", "times"]} /> </PopoverHeader>
                                                                                                    <PopoverBody><div style={{ maxHeight: '90vh', overflowY: 'auto',fontSize:"larger"}}
                                                                                                        dangerouslySetInnerHTML={{ __html: this.state.selectedDescription }} /></PopoverBody>
                                                                                        </Popover></> :  data.createDt
                                                                                        }
                                                                                    </td>
                                                                                    <td style={{ width: "120px" }}>{ data.nickname }</td>
                                                                                  </tr>
                                                                                )
                                                                              }
                                                                              </tbody>
                                                                            </table>
                                                                        </Tab>
                                                                    )
                                                                  }

                                                                  }
                                                                })
                                                                }
                                                              </Tabs>
                                                            </div>
                                                          }
                                                        </PopoverBody>
                                                        <PopoverBody style={visiblityDiv} className={`patient-note-info ${this.state.showPatientDetails ? "d-none" : ""}`}>
                                                          <div class="tab-content tab-content1">
                                                          <table className="follow-up-table" style={{ border: "1px solid #000", color: "#000", width: '100%' }}>
                                                              <tbody>
                                                                <tr style={{backgroundColor: '#bdede4'}}>
                                                                  <td style={{ width: "200px", fontWeight:'bold' }}>Note Details</td>
                                                                  <td style={{ width: "106px", textAlign: 'center', fontWeight:'bold' }}>Create Date</td>
                                                                </tr>
                                                                {
                                                                    patientNoteList.map((data, i) => 
                                                                    <tr key={i}>
                                                                      <td style={{paddingLeft:"10px"}}>
                                                                        <span onClick={(e) => this.patientNoteExpand(true, data.patientNoteId)}>{this.state.expandPatientNoteFor == data.patientNoteId ?  <FontAwesomeIcon icon={["fa", "minus"]} style={{color:"#34bfa3", fontSize:"16px", cursor:"pointer"}}/> : <FontAwesomeIcon icon={["fa", "plus"]} style={{color:"#34bfa3", fontSize:"16px", cursor:"pointer"}}/> } </span><span style={{paddingLeft:"5px"}}>{data.title}</span>
                                                                        <div id={data.patientNoteId}  class={`${ this.state.expandPatientNoteFor == data.patientNoteId ? "" : "d-none"}`} style={{marginTop:"15px"}}>{data.noteDescription}</div>
                                                                      </td>
                                                                      <td>{data.createDt}</td>
                                                                    </tr>
                                                                    )
                                                                  }
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </PopoverBody>
                                                      </Loader>
                                                    </Popover>
                                                  </div> : "-"}
                                              </div>
                                            )
                                          },
                                          ...this.state.currentSortOrderNonPap,
                                        },
                                        {
                                          title: 'Doctor Name',
                                          field: 'physician',
                                          render: rowData => {
                                            return rowData.physician ? rowData.physician : '-';
                                          },
                                        },
                                        {
                                          title: 'DOB',
                                          field: 'dob',
                                          type: "date",
                                          width: "150px",
                                          render: rowData => {
                                            return rowData.dob ? rowData.dob : '-';
                                          }
                                        },
                                        {
                                          title: 'Phone',
                                          field: 'phone',
                                          render: rowData => {
                                            return rowData.phone ? rowData.phone : '-';
                                          }
                                        },
                                      ]}
                                      data={this.props.nonPAPSalesOrderDetailsListByStatus ? this.props.nonPAPSalesOrderDetailsListByStatus : []}
                                      totalCount={this.props.nonPAPSalesOrderDetailsListByStatus ? this.props.nonPAPSalesOrderDetailsListByStatus.length : 0}
                                      isLoading={this.state.isLoadingNonPap}
                                      onOrderChange={this.changeOrderByNonPap}
                                      localization={{
                                        body: {
                                          emptyDataSourceMessage: this.state.isLoadingNonPap == true
                                            ? "Loading..." : "No sales order to display"
                                        }
                                      }}
                                      options={{
                                        maxBodyHeight: 350,

                                        minBodyHeight: this.props.nonPAPSalesOrderDetailsListByStatusTotalRecords == 0 ? 0 : 350,
                                        overflowY: "auto",
                                        padding: "dense",
                                        searchFieldAlignment: 'left',
                                        showTitle: false,
                                        toolbar: true,
                                        actionsColumnIndex: -1,
                                        search: true,
                                        draggable: false,
                                        pageSize: 10,
                                        cellStyle: {
                                          padding: "10px",
                                          color: '#575962',
                                          fontSize: "13px",
                                        },
                                        headerStyle: {
                                          backgroundColor: '#f4f3f8',
                                          color: '#575962',
                                          padding: "15px 10px",
                                          fontSize: "13px",
                                        },
                                        paging: this.props.nonPAPSalesOrderDetailsListByStatusTotalRecords == 0 ? false : true,
                                        pageSizeOptions: [5, 10, 20, 50, 100]
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>

      </>
    )
  }
}

Dashboard = reduxForm({
  form: 'Dashboard',
  // validate,
  asyncValidate,
  enableReinitialize: true,
  destroyOnUnmount: false
})(Dashboard);

function mapStateToProps(state, props) {
  return {
    loading: state.auth.loading,
    PtKey: state.auth.user.PtKey,
    referralParam: state.auth.referralParam,
    organizationParam: state.auth.organizationParam,
    roleId: state.auth.user.roleId,
    userId: state.auth.user.userId,
    isPapUser: state.auth.user.isPapUser,
    globalSummaryAccess: state.auth.user.globalSummaryAccess,
    sleepScreenerAccess: state.auth.user.sleepScreenerAccess,
    //isPapUser: 0,

    userData: state.auth.fetchSalesOrderFilterListresponse != undefined ? state.auth.fetchSalesOrderFilterListresponse.liSalesOrderFilterResponse : [],
    userDataLoading: state.auth.fetchSalesOrderFilterListResponseLoading != undefined ? state.auth.fetchSalesOrderFilterListResponseLoading : [],
    userDataAdherenceInfo: state.auth.fetchSalesOrderFilterListAdherenceInforesponse != undefined ? state.auth.fetchSalesOrderFilterListAdherenceInforesponse.liGetAveragePatientUsageData : [],
    totalRecords: state.auth.fetchSalesOrderFilterListresponse !== undefined ? state.auth.fetchSalesOrderFilterListresponse.listCount : 0,
    chartData: state.auth.fetchChartDetailresponse !== undefined ? state.auth.fetchChartDetailresponse.liComplaintCountResponse : [],
    chartDataDeliveredUndelivered: state.auth.fetchChartDetailresponse !== undefined ? state.auth.fetchChartDetailresponse.liDeliveredAndUndeliveredResponse : [],
    chartDataLoading: state.auth.fetchChartDetailResponseLoading !== undefined ? state.auth.fetchChartDetailResponseLoading : [],
    //fetchDashboardDetailresponse,

    dashboardDetailsOrderBreakDown: state.auth.fetchDashboardDetailresponse !== undefined ? state.auth.fetchDashboardDetailresponse.liSalesOrderBreakDownResponse : [],
    dashboardDetailsOrderBreakDownLoading: state.auth.fetchDashboardDetailResponseLoading !== undefined ? state.auth.fetchDashboardDetailResponseLoading : [],
    dashboardDetailsAdherenceBreakDown: state.auth.fetchDashboardDetailresponse !== undefined ? state.auth.fetchDashboardDetailresponse.liComplianceBreakDownResponse : [],

    adherenceBreakdownDetail: state.auth.adherenceBreakdownDetail !== undefined ? state.auth.adherenceBreakdownDetail.liComplianceBreakDownResponse : [],
    adherenceBreakdownDetailNum: state.auth.AdherenceBreakdownDetailNum,

    resmedSummaryDocSuccess: state.auth.resmedSummaryDocSuccess !== undefined ? state.auth.resmedSummaryDocSuccess.documentPath : '',
    nonPAPSalesOrderDetailsListByStatus: state.auth.nonPAPSalesOrderDetailsListByStatus != undefined ? state.auth.nonPAPSalesOrderDetailsListByStatus.liNonPAPSalesOrderByFiltersResponse ? state.auth.nonPAPSalesOrderDetailsListByStatus.liNonPAPSalesOrderByFiltersResponse : state.auth.nonPAPSalesOrderDetailsListByStatus.liNonPAPSalesOrderByStatusResponse : [],
    nonPAPSalesOrderDetailsListByStatusLoading: state.auth.nonPAPSalesOrderDetailsListByStatusLoading != undefined ? state.auth.nonPAPSalesOrderDetailsListByStatusLoading : [],

    nonPAPSalesOrderDetailsListByStatusTotalRecords: state.auth.nonPAPSalesOrderDetailsListByStatus != undefined ? state.auth.nonPAPSalesOrderDetailsListByStatus.listCount : 0,
    nonPAPDashboardDetails: state.auth.nonPAPDashboardDetails != undefined && state.auth.nonPAPDashboardDetails.liNonPAPSalesOrderBreakDownResponse != null && state.auth.nonPAPDashboardDetails.liNonPAPSalesOrderBreakDownResponse.length > 0 ? state.auth.nonPAPDashboardDetails.liNonPAPSalesOrderBreakDownResponse : [],
    nonPAPDashboardDetailsLoading: state.auth.nonPAPDashboardDetailsLoading,
    chartNonPapDataDeliveredUndelivered: state.auth.nonPAPChartDetail != undefined && state.auth.nonPAPChartDetail.success == true && state.auth.nonPAPChartDetail.liNonPAPDeliveredAndUndeliveredResponse.length > 0 ? state.auth.nonPAPChartDetail.liNonPAPDeliveredAndUndeliveredResponse : [],
    chartNonPapDataDeliveredUndeliveredLoading: state.auth.nonPAPChartDetailLoading != undefined ? state.auth.nonPAPChartDetailLoading : [],
    nonPAPPatientDetail: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.liNonPAPPatientDataResponse.length > 0 ? state.auth.nonPAPPatientDetail.liNonPAPPatientDataResponse : [],
    nonPAPPatientCounter: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.message=="Patient information not found for this patient." ? true : false,
    liCancelledOrderResponse: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.success == true && state.auth.nonPAPPatientDetail.liCancelledOrderResponse  != null ? state.auth.nonPAPPatientDetail.liCancelledOrderResponse : [],
    liOutsourcedOrderResponse: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.liOutsourcedOrderResponse != null ? state.auth.nonPAPPatientDetail.liOutsourcedOrderResponse : [],
    isInternalRole: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.isInternalRole != null ? state.auth.nonPAPPatientDetail.isInternalRole : false,
    patientNoteList: state.auth.nonPAPPatientDetail != undefined && state.auth.nonPAPPatientDetail.liPatientNotesDetailResponse ? state.auth.nonPAPPatientDetail.liPatientNotesDetailResponse : [],

    profile: state.Profile,
    initialValues: {
      firstName: state.auth.firstName,
      lastName: state.auth.lastName,
      Email: state.auth.email,
      PhoneNumber: state.auth.phone,
      // imagePath: state.auth.user[0].ImagePath,
    },

    response: state.auth.response,
    // imagePath: state.auth.user[0].ImagePath,
    responseProfileImg: state.auth.responseProfileImg,
    filterRes: state.auth.filterRes,
    salesFilter: state.auth.salesFilter,
    isScrollToList: state.auth.isScrollToList,
    isFilterClear: state.auth.isFilterClear,
    checkForMenuItemAccess: state.auth.checkForMenuItemAccessresponse != undefined ? state.auth.checkForMenuItemAccessresponse : [],
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSalesOrderFilterListRequest: ({
      statusParam,
      salesRepParam,
      doctorParam,
      doctorNameParam,
      doctorFirstNameParam,
      doctorLastNameParam,
      insuranceParam,
      maskTypeParam,
      complianceRiskParam,
      equipmentTypeParam,
      daysSinceSetupParam,
      organizationParam,
      referralParam,
      // "limitParam": "10000",
      startDate,
      endDate,
      patientNameParam,
      patientFirstNameParam,
      patientNameLastParam,
      dateOfBirthParam,
      // "rowsToSkip": "0",
      orderByFieldParam,
      sortOrderParam,
      PageSize,
      PageNo
    }) => dispatch(auth.actions.fetchSalesOrderFilterListRequest({
      statusParam,
      salesRepParam,
      doctorParam,
      doctorNameParam,
      doctorFirstNameParam,
      doctorLastNameParam,
      insuranceParam,
      maskTypeParam,
      complianceRiskParam,
      equipmentTypeParam,
      daysSinceSetupParam,
      organizationParam,
      referralParam,
      // "limitParam": "10000",
      startDate,
      endDate,
      patientNameParam,
      patientFirstNameParam,
      patientNameLastParam,
      dateOfBirthParam,
      // "rowsToSkip": "0",
      orderByFieldParam,
      sortOrderParam,
      PageSize,
      PageNo
    })),

    fetchSalesOrderFilterListAdherenceInfoRequest: ({
      ptKey
    }) => dispatch(auth.actions.fetchSalesOrderFilterListAdherenceInfoRequest({
      ptKey
    })),
    saveSalesFilter: (data, isScrollToList) => dispatch(auth.actions.saveSalesFilter(data, isScrollToList)),
    saveProfileImage: ({ files }) => dispatch(auth.actions.saveProfileImage({ files })),
    fetchDashboardDetailRequest: ({ AuthToken, OrganizationParam, ReferralParam, RoleId, UserId }) => dispatch(auth.actions.fetchDashboardDetailRequest({ AuthToken, OrganizationParam, ReferralParam, RoleId, UserId })),
    fetchChartDetailRequest: ({ AuthToken, OrganizationParam, ReferralParam, UserId }) => dispatch(auth.actions.fetchChartDetailRequest({ AuthToken, OrganizationParam, ReferralParam, UserId })),
    fetchAdherenceBreakdownDetailRequest: ({ Type }) => dispatch(auth.actions.fetchAdherenceBreakdownDetailRequest({ Type })),
    clearFilter: (data) => dispatch(auth.actions.clearFilter(data)),
    fetchResmedSummaryDocRequest: (data) => dispatch(auth.actions.fetchResmedSummaryDocRequest(data)),
    fetchNonPAPSalesOrderDetailsListByStatusRequest: ({ ReferralParam, IsStatusNameParam, StatusNameParam }) => dispatch(auth.actions.fetchNonPAPSalesOrderDetailsListByStatusRequest({ ReferralParam, IsStatusNameParam, StatusNameParam })),
    fetchNonPAPDashboardDetailsRequest: ({ ReferralParam, RoleId, OrganizationParam }) => dispatch(auth.actions.fetchNonPAPDashboardDetailsRequest({ ReferralParam, RoleId, OrganizationParam })),
    fetchNonPAPChartDetailRequest: ({ ReferralParam, OrganizationParam }) => dispatch(auth.actions.fetchNonPAPChartDetailRequest({ ReferralParam, OrganizationParam })),
    fetchNonPAPPatientDetailRequest: ({ ReferralKey, PatientNameParam }) => dispatch(auth.actions.fetchNonPAPPatientDetailRequest({ ReferralKey, PatientNameParam })),
    checkForMenuItemAccessRequest: () => {
      dispatch(auth.actions.checkForMenuItemAccessRequest())
    },
    fetchMaskTypeListRequest :({ ReferralParam, OrganizationParam}) => dispatch(auth.actions.fetchMaskTypeListRequest({ReferralParam, OrganizationParam})),
    storeNonPapPatientDataNull: () => dispatch(auth.actions.storeNonPapPatientDataNull()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
